// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 운영도구 - 올인원 페이지 (PR1 셸 단계) */

/* App.css 전역 button 규칙(min-height:60px / font-size:20px)이 AntD pagination
   prev/next 버튼에 적용되어 페이지 번호(<li>)와 수직 정렬이 어긋나는 문제 보정 */
.ant-pagination .ant-pagination-prev,
.ant-pagination .ant-pagination-next,
.ant-pagination .ant-pagination-jump-prev,
.ant-pagination .ant-pagination-jump-next,
.ant-pagination .ant-pagination-prev button,
.ant-pagination .ant-pagination-next button,
.ant-pagination .ant-pagination-item,
.ant-pagination .ant-pagination-options .ant-select-selector {
  min-height: 0 !important;
  height: 28px !important;
  line-height: 26px !important;
  font-size: 14px !important;
  vertical-align: middle !important;
}
.ant-pagination .ant-pagination-item a {
  line-height: 26px !important;
}

/* App.css 전역 input { min-height:60px } 가 AntD 내부 input 까지 부풀리는 문제 보정 */
.ant-modal .ant-input,
.ant-modal .ant-input-sm,
.ant-modal .ant-picker,
.ant-modal .ant-picker-small,
.ant-modal .ant-picker-input > input,
.ant-modal .ant-select-selector,
.ant-modal .ant-select-selection-search-input {
  min-height: 0 !important;
}
.ant-modal .ant-input-sm,
.ant-modal .ant-picker-small {
  height: 28px !important;
}
.ant-modal .ant-picker-small .ant-picker-input > input {
  height: 26px !important;
  font-size: 13px !important;
}

.all-in-one-page {
  display: flex;
  flex-direction: column;
  height: 100vh;
  height: 100dvh;
  background: #ECEFF1;
  font-family: "Noto Sans KR", sans-serif;
  position: relative;
}

/* 전역 API 펜딩 오버레이 — 모든 axios 요청 진행 중 인터랙션 차단 */
.api-busy-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  background: rgba(38, 50, 56, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: wait;
  -webkit-user-select: none;
  user-select: none;
  touch-action: none;
}
.api-busy-overlay.done {
  opacity: 0;
  pointer-events: none;
}
.api-busy-card {
  background: #fff;
  border-radius: 14px;
  padding: 22px 28px;
  min-width: 240px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  box-shadow: 0 6px 24px rgba(0,0,0,0.18);
}
.api-busy-text {
  font-size: 16px;
  font-weight: 700;
  color: #263238;
}
.api-busy-sub {
  font-size: 12px;
  color: #607D8B;
}
.api-busy-check {
  font-size: 36px;
  line-height: 1;
}
.all-header {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px;
  background: #fff;
  border-bottom: 1px solid #CFD8DC;
  min-height: 48px;
}

.all-header-left,
.all-header-right {
  display: flex;
  align-items: center;
  gap: 12px;
}

.all-header-title {
  font-size: 18px;
  font-weight: 600;
  color: #263238;
}

.all-user-name {
  font-size: 14px;
  color: #546E7A;
}

.all-main {
  flex: 1 1 auto;
  display: flex;
  min-height: 0;
  gap: 10px;
  padding: 10px;
}

.all-pane {
  background: #fff;
  border: 1px solid #D7E0E6;
  border-radius: 14px;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
  box-shadow: 0 3px 12px rgba(38, 50, 56, 0.06);
}

.all-pane-left   {
  flex: 0 0 clamp(250px, 26vw, 320px);
  background: #FBFCFD;
}
.all-pane-center { flex: 1 1 50%; }
.all-pane-right  { flex: 0 0 22%; }

.pane-title {
  flex: 0 0 auto;
  padding: 11px 14px;
  font-size: clamp(14px, 1.3vw, 16px);
  font-weight: 700;
  color: #263238;
  background: #F2F6F8;
  border-bottom: 2px solid #DCE5EA;
}

/* 검색은 조회 후에도 계속 사용하는 핵심 도구다. 영역을 없애지 않고 입력부의 경계를 강화한다. */
.all-in-one-page .all-pane-left .phone-numpad {
  padding: 12px;
}

.all-in-one-page .all-pane-left .phone-display {
  display: grid;
  grid-template-columns: 48px minmax(0, 1fr);
  align-items: center;
  gap: 8px;
  min-height: 58px;
  padding: 8px 10px;
  border: 2px solid #CE93D8;
  border-radius: 13px;
  background: #FFFFFF;
  box-shadow: 0 3px 9px rgba(123, 31, 162, 0.09);
  overflow: hidden;
}

.all-in-one-page .all-pane-left .phone-prefix {
  width: 48px;
  color: #455A64;
  font-size: 20px;
  font-weight: 800;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
}

.all-in-one-page .all-pane-left .phone-digits {
  display: grid;
  grid-template-columns: repeat(8, minmax(0, 1fr));
  align-items: center;
  width: 100%;
  min-width: 0;
  gap: 1px;
  color: #263238;
  font-variant-numeric: tabular-nums;
  letter-spacing: 0;
}

.all-in-one-page .all-pane-left .phone-digits > span {
  display: block;
  min-width: 0;
  font-size: clamp(17px, 2vw, 22px);
  font-weight: 700;
  line-height: 1;
  text-align: center;
}

.all-in-one-page .all-pane-left .phone-digits > .placeholder {
  color: #B0BEC5;
  font-weight: 500;
}

.all-in-one-page .all-pane-left .numpad-key {
  border-radius: 11px;
  border-color: #CAD5DC;
  box-shadow: 0 2px 5px rgba(38, 50, 56, 0.08);
  transition: none;
}

.all-in-one-page .all-pane-left .numpad-key:active:not(:disabled) {
  border-color: #607D8B;
  background: #DCE5EA;
}

.all-in-one-page .all-pane-left .numpad-clear {
  color: #B42318;
  border-color: #FDA29B;
  background: #FFF1F0;
}

.all-in-one-page .all-pane-left .numpad-backspace {
  color: #5E35B1;
  border-color: #B39DDB;
  background: #F5F0FF;
}

.all-in-one-page .all-pane-left .phone-submit {
  border-radius: 11px;
}

.pane-placeholder {
  padding: 16px;
  font-size: 13px;
  color: #90A4AE;
  line-height: 1.6;
}

.all-pane-center .ant-tabs {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.all-pane-center .ant-tabs-nav {
  margin: 8px 8px 0;
}

/* 바깥 탭은 서비스 전환, BankTab 안쪽 탭은 실제 업무 선택이다.
   두 단계가 같은 버튼처럼 보이지 않도록 바깥 탭은 작고 차분한 탐색 막대로 유지한다. */
.all-pane-center > .ant-tabs > .ant-tabs-nav {
  margin: 10px 10px 0;
  padding: 5px 6px 0;
  border-radius: 12px 12px 0 0;
  background: #EEF3F6;
}

.all-pane-center > .ant-tabs > .ant-tabs-nav::before {
  border-bottom: 0;
}

.all-pane-center > .ant-tabs > .ant-tabs-nav .ant-tabs-nav-wrap,
.all-pane-center > .ant-tabs > .ant-tabs-nav .ant-tabs-nav-list {
  width: 100%;
}

.all-pane-center > .ant-tabs > .ant-tabs-nav .ant-tabs-nav-list {
  gap: 8px;
}

/* ─── 5개 탭 파스텔 톤 + 액티브 강조 (summary/passport/sticker/bank/alimtalk) ─── */
.all-pane-center .ant-tabs-card > .ant-tabs-nav .ant-tabs-tab {
  border: 1px solid transparent !important;
  border-bottom: none !important;
  border-radius: 10px 10px 0 0 !important;
  flex: 1 1;
  justify-content: center;
  margin: 0 !important;
  padding: 8px clamp(12px, 1.4vw, 18px) !important;
  min-height: clamp(52px, 7vh, 62px);
  font-weight: 700;
  transition: none !important;
  position: relative;
  top: 0;
}
.all-pane-center .ant-tabs-card > .ant-tabs-nav .ant-tabs-tab .ant-tabs-tab-btn {
  font-size: clamp(14px, 1.25vw, 16px);
}

/* 비활성 탭 — 파스텔 백그라운드 (탭별 색상) — 외부 카드탭만 */
.all-pane-center > .ant-tabs > .ant-tabs-nav .ant-tabs-tab:nth-of-type(1) { background: #E3F2FD !important; color: #1565C0 !important; }
.all-pane-center > .ant-tabs > .ant-tabs-nav .ant-tabs-tab:nth-of-type(2) { background: #F3E5F5 !important; color: #6A1B9A !important; }
.all-pane-center > .ant-tabs > .ant-tabs-nav .ant-tabs-tab:nth-of-type(3) { background: #E8F5E9 !important; color: #2E7D32 !important; }
.all-pane-center > .ant-tabs > .ant-tabs-nav .ant-tabs-tab:nth-of-type(4) { background: #FFF8E1 !important; color: #E65100 !important; }
.all-pane-center > .ant-tabs > .ant-tabs-nav .ant-tabs-tab:nth-of-type(5) { background: #FCE4EC !important; color: #AD1457 !important; }

/* 호버 (활성 아닌 탭만) — 파스텔 약간 진해짐 */
.all-pane-center > .ant-tabs > .ant-tabs-nav .ant-tabs-tab:not(.ant-tabs-tab-active):not(.ant-tabs-tab-disabled):hover:nth-of-type(1) { background: #BBDEFB !important; }
.all-pane-center > .ant-tabs > .ant-tabs-nav .ant-tabs-tab:not(.ant-tabs-tab-active):not(.ant-tabs-tab-disabled):hover:nth-of-type(2) { background: #E1BEE7 !important; }
.all-pane-center > .ant-tabs > .ant-tabs-nav .ant-tabs-tab:not(.ant-tabs-tab-active):not(.ant-tabs-tab-disabled):hover:nth-of-type(3) { background: #C8E6C9 !important; }
.all-pane-center > .ant-tabs > .ant-tabs-nav .ant-tabs-tab:not(.ant-tabs-tab-active):not(.ant-tabs-tab-disabled):hover:nth-of-type(4) { background: #FFECB3 !important; }
.all-pane-center > .ant-tabs > .ant-tabs-nav .ant-tabs-tab:not(.ant-tabs-tab-active):not(.ant-tabs-tab-disabled):hover:nth-of-type(5) { background: #F8BBD0 !important; }

/* 활성 탭 — 진한 색 + 흰 글자 + 위로 살짝 솟음 + 굵은 하단 강조선 */
.all-pane-center > .ant-tabs > .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab-active {
  transform: none;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
  font-weight: 800 !important;
}
.all-pane-center > .ant-tabs > .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab-active::after {
  content: none;
}
.all-pane-center > .ant-tabs > .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
  color: #fff !important;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);
}

.all-pane-center > .ant-tabs > .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab-active:nth-of-type(1) { background: #1976D2 !important; color: #fff !important; }
.all-pane-center > .ant-tabs > .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab-active:nth-of-type(2) { background: #7B1FA2 !important; color: #fff !important; }
.all-pane-center > .ant-tabs > .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab-active:nth-of-type(3) { background: #2E7D32 !important; color: #fff !important; }
.all-pane-center > .ant-tabs > .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab-active:nth-of-type(4) { background: #F57C00 !important; color: #fff !important; }
.all-pane-center > .ant-tabs > .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab-active:nth-of-type(5) { background: #C2185B !important; color: #fff !important; }

/* 비활성(disabled — 회원 미식별) 상태는 더 흐리게 */
.all-pane-center > .ant-tabs > .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab-disabled {
  opacity: 0.55;
  filter: saturate(0.5);
}

/* 콘텐츠 영역에 액티브 탭 색상 톤의 옅은 백그라운드 — 외부 탭만 */
.all-pane-center > .ant-tabs > .ant-tabs-content-holder {
  border-top: 3px solid transparent;
  background: #FAFAFA;
}
.all-pane-center > .ant-tabs:has(> .ant-tabs-nav .ant-tabs-tab-active:nth-of-type(1)) > .ant-tabs-content-holder { background: #F5FAFE; border-top-color: #1976D2; }
.all-pane-center > .ant-tabs:has(> .ant-tabs-nav .ant-tabs-tab-active:nth-of-type(2)) > .ant-tabs-content-holder { background: #FBF6FC; border-top-color: #7B1FA2; }
.all-pane-center > .ant-tabs:has(> .ant-tabs-nav .ant-tabs-tab-active:nth-of-type(3)) > .ant-tabs-content-holder { background: #F6FBF6; border-top-color: #2E7D32; }
.all-pane-center > .ant-tabs:has(> .ant-tabs-nav .ant-tabs-tab-active:nth-of-type(4)) > .ant-tabs-content-holder { background: #FFFBEF; border-top-color: #F57C00; }
.all-pane-center > .ant-tabs:has(> .ant-tabs-nav .ant-tabs-tab-active:nth-of-type(5)) > .ant-tabs-content-holder { background: #FDF3F7; border-top-color: #C2185B; }

.all-pane-center .ant-tabs-content-holder {
  flex: 1 1 auto;
  overflow: auto;
  padding: 0 clamp(10px, 1.4vw, 20px) clamp(10px, 1.4vw, 20px);
}

.tab-placeholder {
  padding: 24px;
  color: #607D8B;
}

.tab-placeholder h3 {
  margin: 0 0 8px;
  color: #263238;
}

.tab-pane {
  padding: clamp(10px, 1.4vw, 20px);
}

/* 회원 검색 전 빈 상태: 넓은 작업영역 안에서 안내가 묻히지 않게 한다. */
.all-pane-center .ant-empty-normal {
  width: min(460px, 78%);
  margin: clamp(52px, 14vh, 130px) auto 0;
  padding: clamp(28px, 4vw, 52px);
  border: 2px dashed #CBD8E0;
  border-radius: 22px;
  background: rgba(255, 255, 255, 0.82);
}

.all-pane-center .ant-empty-normal .ant-empty-image {
  height: clamp(84px, 11vw, 124px);
  margin-bottom: 14px;
}

.all-pane-center .ant-empty-normal .ant-empty-description {
  color: #455A64;
  font-size: clamp(18px, 1.65vw, 22px);
  font-weight: 700;
}

.session-log-list {
  list-style: none;
  margin: 0;
  padding: 8px 12px;
  overflow-y: auto;
}

.session-log-item {
  display: flex;
  gap: 8px;
  padding: 6px 4px;
  border-bottom: 1px solid #ECEFF1;
  font-size: 12px;
}

.session-log-ts {
  color: #90A4AE;
  font-family: ui-monospace, "Menlo", monospace;
  flex-shrink: 0;
}

.session-log-msg {
  color: #263238;
  word-break: keep-all;
}

/* ── 작업 로그 접이식 토글 (화면 좁음 대응) ───────────────────── */
/* 접힘: 얇은 세로 띠로 축소 → .all-pane-center(flex:1 1) 가 남는 폭을 자동 흡수 */
.all-pane-right.is-collapsed {
  flex: 0 0 34px;
  min-width: 34px;
  cursor: pointer;
}

/* 확장 상태 헤더: 제목 + 접기 버튼 한 줄 */
.pane-title-log {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/* 공통 토글 버튼 */
.session-log-toggle {
  border: none;
  background: transparent;
  color: #607D8B;
  cursor: pointer;
  padding: 0;
  font-size: 13px;
  line-height: 1;
}
.session-log-toggle.is-expanded {
  padding: 2px 6px;
  border-radius: 4px;
}
.session-log-toggle.is-expanded:hover {
  background: #ECEFF1;
  color: #37474F;
}

/* 접힘 상태: 세로 세워진 라벨 + 화살표(패널 전체가 버튼) */
.session-log-toggle.is-collapsed {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 12px 0;
  color: #607D8B;
}
.session-log-toggle.is-collapsed:hover {
  background: #F5F7F8;
  color: #37474F;
}
.session-log-toggle-arrow {
  font-size: 14px;
}
.session-log-toggle-label {
  writing-mode: vertical-rl;
  text-orientation: mixed;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 1px;
}
.session-log-toggle-badge {
  margin-top: auto;
  min-width: 18px;
  padding: 1px 5px;
  border-radius: 9px;
  background: #455A64;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  text-align: center;
}

.sticker-family-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.sticker-family-card {
  cursor: pointer;
  border: 1px solid #CFD8DC;
}

.sticker-family-card.selected {
  border-color: #455A64;
  background: #ECEFF1;
}

/* 티켓→전화번호 진행 안내 시 패드 강조 */
.phone-section-flash {
  outline: 3px solid rgba(255, 152, 0, 0.45);
  outline-offset: -3px;
  border-radius: 6px;
}

/* 전화번호 오입력 방지: 올인원 패드의 각 키를 가로 폭과 같은 정사각형 터치 영역으로 유지 */
.all-in-one-page .phone-numpad .numpad-key {
  width: 100%;
  height: auto;
  min-height: 0;
  aspect-ratio: 1 / 1;
}

/* 낮은 가로 화면에서는 정사각형 키가 세로 공간을 넘지 않도록 남은 높이에 맞춰 축소한다. */
@media (orientation: landscape) and (max-height: 900px) {
  .all-in-one-page .all-pane-left > .identify-section {
    flex: 1 1 auto;
    min-height: 0;
  }

  .all-in-one-page .all-pane-left .phone-numpad {
    box-sizing: border-box;
    height: 100%;
    min-height: 0;
    gap: 6px;
    padding: 8px 12px;
  }

  .all-in-one-page .all-pane-left .phone-display {
    flex: 0 0 auto;
    padding: 6px 10px;
  }

  .all-in-one-page .all-pane-left .phone-help,
  .all-in-one-page .all-pane-left .phone-error {
    flex: 0 0 auto;
    line-height: 1.2;
  }

  .all-in-one-page .all-pane-left .numpad-grid {
    flex: 1 1 auto;
    min-height: 0;
    grid-template-rows: repeat(4, minmax(0, 1fr));
  }

  .all-in-one-page .phone-numpad .numpad-key {
    height: 100%;
    aspect-ratio: auto;
  }

  .all-in-one-page .all-pane-left .phone-submit {
    flex: 0 0 clamp(40px, 6.5vh, 48px);
    height: clamp(40px, 6.5vh, 48px);
    min-height: 0;
  }
}

.session-log-list-full { max-height: none; padding: 0; margin: 0; list-style: none; }

/* ─── BankTab ─── */
.bank-tab-allinone {
  display: flex;
  flex-direction: column;
  gap: clamp(8px, 1.1vw, 14px);
  height: 100%;
}

.bank-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
}

/* 가족 선택 정보는 이름·관계·잔액을 말줄임표 없이 모두 표시한다. */
.bank-header .ant-segmented {
  width: 100%;
  padding: 4px;
  border: 1px solid #CFD8E1;
  background: #EAF0F4;
  border-radius: 14px;
  box-shadow: inset 0 1px 2px rgba(38, 50, 56, 0.05);
}

.bank-header .ant-segmented-item-label {
  height: auto;
  min-height: clamp(42px, 5.4vh, 52px);
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: normal;
  overflow: visible;
  text-overflow: clip;
  overflow-wrap: anywhere;
  padding: 5px 10px;
  font-size: clamp(14px, 1.3vw, 17px);
  line-height: 1.25;
}

.bank-header .ant-segmented-item-selected .ant-segmented-item-label {
  font-weight: 800;
  color: #0F5CAD;
}

.bank-header .ant-segmented-item-selected {
  box-shadow: 0 2px 7px rgba(21, 101, 192, 0.14);
}

/* 가족을 누를 때 선택 배경이 미끄러지지 않고 즉시 바뀌게 한다. */
.bank-header .ant-segmented-thumb,
.bank-header .ant-segmented-item,
.bank-header .ant-segmented-item::after {
  animation: none !important;
  transition: none !important;
}

.bank-pane {
  display: flex;
  flex-direction: column;
  gap: clamp(9px, 1vw, 14px);
  padding: clamp(8px, 1vw, 14px) 4px 0;
}

/* 내부 BankTab(인출/저축/기부) — 기능별 파스텔 + 적당한 간격 + 큰 폰트 */
.bank-tab-allinone .ant-tabs-nav .ant-tabs-tab {
  padding: 6px 12px !important;
  width: auto;
  min-height: clamp(54px, 7vh, 64px);
  justify-content: center;
  border-radius: 8px 8px 0 0 !important;
  border: 1px solid transparent !important;
  font-size: clamp(17px, 1.5vw, 20px) !important;
  font-weight: 600 !important;
  line-height: 1.2 !important;
  transition: none !important;
}
.bank-tab-allinone .ant-tabs-nav {
  margin-bottom: 6px !important;
  padding-bottom: 0;
  border-bottom: 1px solid #DCE3E8;
}

.bank-tab-allinone > .ant-tabs > .ant-tabs-nav .ant-tabs-nav-wrap {
  flex: 1 1 auto;
}

.bank-tab-allinone > .ant-tabs > .ant-tabs-nav .ant-tabs-nav-list {
  width: 100%;
}

.bank-tab-allinone > .ant-tabs > .ant-tabs-nav .ant-tabs-tab {
  flex: 1 1;
}
.bank-tab-allinone .ant-tabs-nav .ant-tabs-tab + .ant-tabs-tab {
  margin-left: 3px !important;
}

/* 비활성 — 파스텔 */
.bank-tab-allinone .ant-tabs-nav .ant-tabs-tab:nth-of-type(1) { background: #FFF3E0 !important; color: #E65100 !important; }
.bank-tab-allinone .ant-tabs-nav .ant-tabs-tab:nth-of-type(2) { background: #E3F2FD !important; color: #1565C0 !important; }
.bank-tab-allinone .ant-tabs-nav .ant-tabs-tab:nth-of-type(3) { background: #FCE4EC !important; color: #AD1457 !important; }

/* 호버 (활성 아닌 탭) */
.bank-tab-allinone .ant-tabs-nav .ant-tabs-tab:not(.ant-tabs-tab-active):hover:nth-of-type(1) { background: #FFE0B2 !important; }
.bank-tab-allinone .ant-tabs-nav .ant-tabs-tab:not(.ant-tabs-tab-active):hover:nth-of-type(2) { background: #BBDEFB !important; }
.bank-tab-allinone .ant-tabs-nav .ant-tabs-tab:not(.ant-tabs-tab-active):hover:nth-of-type(3) { background: #F8BBD0 !important; }

/* 활성 — 진한 색 + 흰 글자 */
.bank-tab-allinone .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab-active {
  transform: none;
  box-shadow: inset 0 -5px 0 rgba(0, 0, 0, 0.14);
  font-weight: 800 !important;
}
.bank-tab-allinone .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
  color: #fff !important;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);
}
.bank-tab-allinone .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab-active:nth-of-type(1) { background: #F57C00 !important; }
.bank-tab-allinone .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab-active:nth-of-type(2) { background: #1976D2 !important; }
.bank-tab-allinone .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab-active:nth-of-type(3) { background: #C2185B !important; }

/* 터치에서 툴팁에 의존하지 않도록 이력/새로고침을 서로 다른 보조색으로 구분한다. */
.bank-tab-allinone .ant-tabs-extra-content .ant-space-item .ant-btn {
  min-width: 58px !important;
  height: 56px !important;
  min-height: 56px !important;
  border-radius: 12px;
  font-size: 19px;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08);
}

.bank-tab-allinone .ant-tabs-extra-content .ant-space-item:first-child .ant-btn {
  color: #6A1B9A;
  border-color: #CE93D8;
  background: #FAF5FF;
}

.bank-tab-allinone .ant-tabs-extra-content .ant-space-item:last-child .ant-btn {
  color: #1565C0;
  border-color: #90CAF9;
  background: #F3F8FE;
}

.bank-action-row {
  display: grid;
  grid-template-columns: clamp(190px, 23vw, 250px) minmax(240px, 1fr);
  gap: clamp(10px, 1vw, 14px);
  align-items: stretch;
  min-height: 64px;
}

.bank-balance-card {
  background: linear-gradient(135deg, #FFF7D6, #FFE8A3);
  border: 2px solid #F9C642;
  border-radius: 14px;
  padding: 10px 18px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 2px;
  min-height: 64px;
}

.bank-full-exchange-btn {
  height: 100% !important;
  min-height: 64px;
  font-size: clamp(18px, 1.6vw, 21px) !important;
  font-weight: 800 !important;
  border-radius: 12px !important;
}

.bank-balance-value {
  font-size: clamp(27px, 2.4vw, 34px);
  font-weight: 800;
  color: #FB8C00;
  line-height: 1.1;
}

.bank-balance-unit {
  font-size: clamp(14px, 1.25vw, 17px);
  margin-left: 2px;
  color: #FB8C00;
  font-weight: 600;
}

.bank-input-card {
  background: #fff;
  border: 1px solid #E0E0E0;
  border-radius: 14px;
  padding: clamp(12px, 1.2vw, 18px);
  display: flex;
  flex-direction: column;
  gap: clamp(9px, 1vw, 13px);
  box-shadow: 0 4px 14px rgba(38, 50, 56, 0.08);
}

@media (max-width: 900px) {
  .bank-action-row { grid-template-columns: 1fr; }
}

/* 숫자패드 트리거(클릭 가능 큰 디스플레이) */
.bank-amount-display {
  appearance: none;
  background: linear-gradient(135deg, #FFF9E7, #FFE4AD);
  border: 3px dashed #F5A000;
  border-radius: 14px;
  padding: 12px 14px 10px;
  color: #E65100;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  transition: none;
  width: 100%;
  min-height: clamp(72px, 9vh, 92px);
  line-height: 1;
}
.bank-amount-value {
  font-size: clamp(34px, 3.2vw, 44px);
  font-weight: 800;
  color: #E65100;
  display: inline-flex;
  align-items: baseline;
  gap: 2px;
  line-height: 1;
}
.bank-amount-display:hover:not(:disabled) {
  background: #FFF1CB;
  box-shadow: 0 5px 16px rgba(255, 152, 0, 0.28);
}
.bank-amount-display:active:not(:disabled) {
  transform: none;
  background: #FFE3A0;
}
.bank-amount-display:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.bank-amount-unit {
  font-size: clamp(18px, 1.6vw, 22px);
  margin-left: 4px;
  font-weight: 700;
  color: #E65100;
}
.bank-amount-hint {
  font-size: clamp(12px, 1.1vw, 14px);
  font-weight: 600;
  color: #8D6E63;
  letter-spacing: 0.3px;
}

.bank-pane > .ant-btn {
  min-height: clamp(58px, 7.2vh, 68px) !important;
  font-size: clamp(17px, 1.5vw, 20px) !important;
  font-weight: 800 !important;
  border-radius: 12px !important;
}

/* 실제 후보 중 가장 낮은 600px 높이에서는 정보 크기는 유지하고 여백만 줄인다. */
@media (orientation: landscape) and (max-height: 700px) {
  .all-main { gap: 8px; padding: 8px; }
  .all-pane-left { flex-basis: clamp(250px, 26vw, 270px); }
  .all-pane-center .ant-tabs-content-holder { padding: 0 9px 9px; }
  .tab-pane { padding: 9px; }
  .bank-header .ant-segmented-item-label { min-height: 40px; padding-block: 3px; }
  .bank-tab-allinone .ant-tabs-nav .ant-tabs-tab { min-height: 54px; }
  .bank-tab-allinone .ant-tabs-extra-content .ant-space-item .ant-btn {
    height: 54px !important;
    min-height: 54px !important;
  }
  .bank-action-row,
  .bank-balance-card,
  .bank-full-exchange-btn { min-height: 60px; }
  .bank-input-card { padding: 11px 13px; }
  .bank-amount-display { min-height: 70px; padding-block: 9px 7px; }
  .bank-pane > .ant-btn { min-height: 58px !important; }
}

/* 숫자패드 모달 */
.bank-numpad {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.bank-numpad-display {
  background: #263238;
  color: #FFD54F;
  border-radius: 8px;
  padding: 14px;
  text-align: right;
  font-size: 28px;
  font-weight: 800;
  font-variant-numeric: tabular-nums;
  min-height: 56px;
}
.bank-numpad-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}
.bank-numpad-key {
  appearance: none;
  height: 56px;
  border-radius: 10px;
  border: 1px solid #CFD8DC;
  background: #ECEFF1;
  font-size: 22px;
  font-weight: 700;
  color: #263238;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}
.bank-numpad-key:active {
  background: #B0BEC5;
}
.bank-numpad-key.key-clear {
  background: #FFCDD2;
  color: #C62828;
  border-color: #EF9A9A;
}
.bank-numpad-key.key-back {
  background: #E1BEE7;
  color: #6A1B9A;
  border-color: #CE93D8;
}
.bank-numpad-actions {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}

/* ─── 회원요약 — 헤로 카드 ─── */
.summary-tab { padding: 4px 4px 0; }

.summary-hero {
  background: linear-gradient(135deg, #E3F2FD, #F5FAFE);
  border: 1px solid #90CAF9;
  border-radius: 12px;
  padding: 12px 14px;
  margin-bottom: 12px;
}
.summary-hero-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 10px;
}
.summary-hero-name-wrap { min-width: 0; flex: 1 1 auto; }
.summary-hero-name {
  font-size: 22px;
  font-weight: 800;
  color: #0D47A1;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.summary-hero-tags { margin-top: 4px; display: flex; gap: 4px; flex-wrap: wrap; }
.summary-hero-tags .ant-tag { margin: 0; }
.summary-hero-phone {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: 2px;
  font-size: 14px;
  color: #455A64;
  white-space: nowrap;
}
.summary-phone-text { font-weight: 600; }

.summary-stat-grid {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1.4fr;
  gap: 8px;
}
.summary-stat-cell {
  background: rgba(255, 255, 255, 0.8);
  border-radius: 8px;
  padding: 8px 10px;
  min-width: 0;
}
.summary-stat-label {
  font-size: 11px;
  color: #607D8B;
  font-weight: 500;
  margin-bottom: 2px;
}
.summary-stat-value {
  font-size: 18px;
  font-weight: 700;
  color: #263238;
  line-height: 1.1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.summary-stat-coin { color: #F57C00; }
.summary-stat-date { font-size: 16px; letter-spacing: -0.3px; }
.summary-stat-sub {
  font-size: 11px;
  color: #90A4AE;
  margin-top: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* ─── 가족 카드 리스트 ─── */
.summary-family-section { display: flex; flex-direction: column; gap: 8px; }
.summary-family-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 2px;
}
.summary-family-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.summary-family-card {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  background: #FAFAFA;
  border: 1px solid #E0E0E0;
  border-radius: 10px;
  min-width: 0;
}
.summary-family-card.is-me {
  background: #FFF8E1;
  border-color: #FFD54F;
}
.summary-family-role { margin: 0 !important; flex: 0 0 auto; }
.summary-family-name {
  flex: 1 1 auto;
  min-width: 0;
  font-size: 15px;
  font-weight: 600;
  color: #263238;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.summary-family-coin {
  margin: 0 !important;
  flex: 0 0 auto;
  font-size: 13px;
  font-weight: 700;
}
.summary-family-passport { margin: 0 !important; flex: 0 0 auto; }
.summary-family-actions { flex: 0 0 auto; margin-left: 4px; }
.summary-family-actions .ant-btn { min-width: 36px; height: 26px; min-height: 0 !important; padding: 0 8px !important; line-height: 24px !important; }
.sticker-refresh-btn { height: 26px !important; min-height: 0 !important; padding: 0 10px !important; line-height: 24px !important; font-size: 13px !important; }

/* 좌측 식별 결과 콜아웃 (미등록·티켓없음 등) — 세로 스택, 큰 액션 버튼 */
.identify-callout {
  margin: 8px 12px;
  padding: 12px;
  border-radius: 10px;
  border: 1px solid;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.identify-callout-info {
  background: #E3F2FD;
  border-color: #90CAF9;
}
.identify-callout-error {
  background: #FFEBEE;
  border-color: #EF9A9A;
}
.identify-callout-head {
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 700;
  font-size: 14px;
  color: #1565C0;
}
.identify-callout-error .identify-callout-head { color: #C62828; }
.identify-callout-icon { font-size: 16px; line-height: 1; }
.identify-callout-title { line-height: 1.3; }
.identify-callout-desc {
  font-size: 13px;
  line-height: 1.5;
  color: #37474F;
  word-break: keep-all;
}
.identify-callout-action {
  height: 48px !important;
  font-size: 15px !important;
  font-weight: 700 !important;
  border-radius: 10px !important;
  margin-top: 4px;
}

/* ── 미등록 번호 안내 모달 ─────────────────────────────────────
   인라인 안내가 숫자패드를 화면 밖으로 밀어내서 팝업으로 뺐다(현장 지적 2026-08-21).
   태블릿에서 장갑 낀 손으로도 눌리도록 버튼을 크게 잡는다. */
.no-member-body {
  text-align: center;
  padding: 8px 4px 4px;
}
.no-member-title {
  font-size: 24px;
  font-weight: 800;
  color: #263238;
  margin-bottom: 6px;
}
.no-member-phone {
  font-size: 30px;
  font-weight: 800;
  letter-spacing: 1px;
  color: #1565C0;
  font-variant-numeric: tabular-nums;
  margin-bottom: 12px;
}
.no-member-desc {
  font-size: 15px;
  line-height: 1.6;
  color: #37474F;
  word-break: keep-all;
  margin-bottom: 20px;
}
.no-member-actions {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.no-member-btn {
  height: 68px !important;
  font-size: 20px !important;
  font-weight: 800 !important;
  border-radius: 12px !important;
  white-space: nowrap;
}
.no-member-btn-cancel {
  height: 56px !important;
  font-size: 17px !important;
  font-weight: 700 !important;
}

/* Tablet bank workspace redesign
   Keep the existing controls and events, but separate search, service choice,
   and the active task into three stable touch zones. */
.all-main {
  gap: clamp(8px, 1vw, 14px);
  padding: clamp(8px, 1vw, 14px);
  background: #e8eef3;
}

.all-pane-left {
  flex-basis: clamp(252px, 25vw, 320px);
  border: 0;
  border-radius: 18px;
  box-shadow: 0 4px 18px rgba(31, 50, 68, 0.12);
}

.all-pane-left .pane-title {
  padding: 14px 16px;
  color: #f8fafc;
  background: #24384b;
  border: 0;
}

.all-pane-center {
  border: 0;
  border-radius: 18px;
  background: transparent;
  box-shadow: 0 4px 18px rgba(31, 50, 68, 0.12);
}

/* Outer tabs become a persistent vertical service rail. */
.all-pane-center > .ant-tabs {
  display: grid;
  grid-template-columns: clamp(108px, 11vw, 142px) minmax(0, 1fr);
  grid-template-rows: minmax(0, 1fr);
  min-width: 0;
  background: #f8fafc;
}

.all-pane-center > .ant-tabs > .ant-tabs-nav {
  grid-column: 1;
  grid-row: 1;
  min-width: 0;
  height: 100%;
  margin: 0;
  padding: 14px 10px;
  border-radius: 0;
  background: #24384b;
}

.all-pane-center > .ant-tabs > .ant-tabs-nav .ant-tabs-nav-wrap {
  align-items: flex-start;
  overflow: visible;
}

.all-pane-center > .ant-tabs > .ant-tabs-nav .ant-tabs-nav-list {
  width: 100%;
  flex-direction: column;
  gap: 12px;
  transform: none !important;
}

.all-pane-center > .ant-tabs.ant-tabs-card > .ant-tabs-nav .ant-tabs-tab {
  flex: 0 0 auto;
  width: 100%;
  min-height: clamp(76px, 10vh, 96px);
  padding: 10px 7px !important;
  border: 2px solid transparent !important;
  border-radius: 14px !important;
  box-shadow: none;
}

.all-pane-center > .ant-tabs.ant-tabs-card > .ant-tabs-nav .ant-tabs-tab .ant-tabs-tab-btn {
  width: 100%;
  white-space: normal;
  text-align: center;
  font-size: clamp(15px, 1.35vw, 18px);
  line-height: 1.35;
}

.all-pane-center > .ant-tabs > .ant-tabs-nav .ant-tabs-tab:nth-of-type(1) {
  color: #c7ddf4 !important;
  background: #314b63 !important;
}

.all-pane-center > .ant-tabs > .ant-tabs-nav .ant-tabs-tab:nth-of-type(2) {
  color: #e9d7f2 !important;
  background: #3b4560 !important;
}

.all-pane-center > .ant-tabs > .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab-active:nth-of-type(1) {
  color: #fff !important;
  background: #0878d1 !important;
  border-color: #8dccff !important;
  box-shadow: 0 5px 14px rgba(0, 83, 151, 0.36);
}

.all-pane-center > .ant-tabs > .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab-active:nth-of-type(2) {
  color: #fff !important;
  background: #7738a2 !important;
  border-color: #d7aaf2 !important;
  box-shadow: 0 5px 14px rgba(67, 22, 98, 0.36);
}

.all-pane-center > .ant-tabs > .ant-tabs-content-holder,
.all-pane-center > .ant-tabs:has(> .ant-tabs-nav .ant-tabs-tab-active:nth-of-type(1)) > .ant-tabs-content-holder,
.all-pane-center > .ant-tabs:has(> .ant-tabs-nav .ant-tabs-tab-active:nth-of-type(2)) > .ant-tabs-content-holder {
  grid-column: 2;
  grid-row: 1;
  min-width: 0;
  min-height: 0;
  padding: 12px;
  border-top: 0;
  border-left: 0;
  background: #edf3f7;
}

.all-pane-center > .ant-tabs > .ant-tabs-content-holder > .ant-tabs-content {
  height: 100%;
}

.all-pane-center > .ant-tabs > .ant-tabs-content-holder .ant-tabs-tabpane {
  height: 100%;
}

.all-pane-center .tab-pane {
  height: 100%;
  padding: 0;
}

/* The bank itself reads as one workspace, with identity above and actions below. */
.bank-tab-allinone {
  gap: 12px;
}

.bank-header .ant-segmented {
  padding: 5px;
  border: 0;
  border-radius: 15px;
  background: #dfe8ef;
}

.bank-header .ant-segmented-item {
  border-radius: 11px;
}

.bank-header .ant-segmented-item-selected {
  color: #083f73;
  background: #fff;
  box-shadow: 0 2px 8px rgba(31, 50, 68, 0.16);
}

.bank-tab-allinone > .ant-tabs {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.bank-tab-allinone > .ant-tabs > .ant-tabs-nav {
  flex: 0 0 auto;
  margin: 0 0 12px !important;
  padding: 0;
  border: 0;
  background: #fff;
  border-radius: 15px;
  box-shadow: 0 2px 8px rgba(31, 50, 68, 0.1);
  overflow: hidden;
}

.bank-tab-allinone > .ant-tabs > .ant-tabs-nav::before {
  border: 0;
}

.bank-tab-allinone > .ant-tabs > .ant-tabs-nav .ant-tabs-tab {
  min-height: clamp(62px, 8vh, 78px);
  margin: 0 !important;
  border-radius: 0 !important;
}

.bank-tab-allinone > .ant-tabs > .ant-tabs-content-holder {
  flex: 1 1 auto;
  min-height: 0;
  overflow: auto;
}

.bank-tab-allinone > .ant-tabs > .ant-tabs-content-holder > .ant-tabs-content,
.bank-tab-allinone > .ant-tabs > .ant-tabs-content-holder .ant-tabs-tabpane {
  height: 100%;
}

/* Each operation uses two large task cards instead of a vertical form stack. */
.bank-pane {
  height: 100%;
  display: grid;
  grid-template-columns: minmax(180px, 0.78fr) minmax(275px, 1.22fr);
  grid-template-rows: minmax(0, 1fr);
  gap: clamp(12px, 1.4vw, 20px);
  padding: 0;
}

.bank-action-row {
  min-width: 0;
  min-height: 0;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: minmax(92px, 0.72fr) minmax(74px, 1fr);
  gap: 12px;
}

.bank-pane > .bank-balance-card,
.bank-pane > .ant-alert {
  min-width: 0;
  min-height: 0;
  height: 100%;
}

.bank-balance-card {
  min-height: 92px;
  padding: clamp(14px, 1.6vw, 22px);
  border: 0;
  border-radius: 18px;
  background: #fff0bd;
  box-shadow: inset 0 0 0 2px #f4bd32;
}

.bank-full-exchange-btn {
  min-height: 74px;
  border-radius: 18px !important;
}

.bank-input-card {
  min-width: 0;
  min-height: 0;
  height: 100%;
  justify-content: space-between;
  padding: clamp(16px, 1.7vw, 24px);
  border: 0;
  border-radius: 18px;
  box-shadow: 0 3px 14px rgba(31, 50, 68, 0.12);
}

.bank-amount-display {
  flex: 1 1 auto;
  min-height: 94px;
  max-height: 180px;
  border-radius: 16px;
}

.bank-pane > .ant-alert {
  display: flex;
  align-items: center;
  padding: clamp(18px, 2vw, 28px);
  border: 0;
  border-radius: 18px;
  font-size: clamp(14px, 1.3vw, 17px);
}

.bank-pane > .ant-btn {
  min-height: 64px !important;
}

@media (orientation: landscape) and (max-height: 700px) {
  .all-pane-center > .ant-tabs {
    grid-template-columns: 106px minmax(0, 1fr);
  }

  .all-pane-center > .ant-tabs > .ant-tabs-nav {
    padding: 10px 8px;
  }

  .all-pane-center > .ant-tabs.ant-tabs-card > .ant-tabs-nav .ant-tabs-tab {
    min-height: 72px;
  }

  .all-pane-center > .ant-tabs > .ant-tabs-content-holder,
  .all-pane-center > .ant-tabs:has(> .ant-tabs-nav .ant-tabs-tab-active:nth-of-type(1)) > .ant-tabs-content-holder,
  .all-pane-center > .ant-tabs:has(> .ant-tabs-nav .ant-tabs-tab-active:nth-of-type(2)) > .ant-tabs-content-holder {
    padding: 10px;
  }

  .bank-tab-allinone {
    gap: 8px;
  }

  .bank-tab-allinone > .ant-tabs > .ant-tabs-nav {
    margin-bottom: 8px !important;
  }

  .bank-tab-allinone > .ant-tabs > .ant-tabs-nav .ant-tabs-tab {
    min-height: 54px;
  }

  .bank-pane {
    gap: 10px;
  }

  .bank-action-row {
    grid-template-rows: minmax(76px, 0.7fr) minmax(64px, 1fr);
    gap: 8px;
  }

  .bank-balance-card,
  .bank-full-exchange-btn {
    min-height: 64px;
  }

  .bank-input-card {
    padding: 12px;
  }

  .bank-amount-display {
    min-height: 76px;
  }
}

@media (max-width: 820px) {
  .all-pane-center > .ant-tabs {
    grid-template-columns: 96px minmax(0, 1fr);
  }

  .bank-pane {
    grid-template-columns: 1fr;
    grid-template-rows: auto auto;
  }

  .bank-action-row {
    grid-template-columns: minmax(150px, 0.8fr) minmax(210px, 1.2fr);
    grid-template-rows: minmax(70px, auto);
  }
}

/* Tablet bank workspace v2
   Operator flow: phone search -> family member -> transaction. */
.all-in-one-page *,
.all-in-one-page *::before,
.all-in-one-page *::after {
  animation: none !important;
  transition: none !important;
  scroll-behavior: auto !important;
}

.all-main {
  gap: 8px;
  padding: 8px;
  background: #dfe6ec;
}

.all-pane-left {
  flex-basis: clamp(246px, 26vw, 300px);
  border-radius: 10px;
  box-shadow: none;
}

.all-pane-left .pane-title {
  padding: 11px 14px;
  background: #17334a;
}

.all-pane-center {
  border-radius: 10px;
  box-shadow: none;
}

/* Service choice: a full-width, two-way switch above the work surface. */
.all-pane-center > .ant-tabs {
  display: flex;
  flex-direction: column;
  min-width: 0;
  background: #f7f9fb;
}

.all-pane-center > .ant-tabs > .ant-tabs-nav {
  flex: 0 0 auto;
  width: auto;
  height: auto;
  margin: 0;
  padding: 8px;
  border-radius: 0;
  background: #17334a;
}

.all-pane-center > .ant-tabs > .ant-tabs-nav .ant-tabs-nav-wrap {
  align-items: stretch;
  overflow: hidden;
}

.all-pane-center > .ant-tabs > .ant-tabs-nav .ant-tabs-nav-list {
  width: 100%;
  flex-direction: row;
  gap: 8px;
}

.all-pane-center > .ant-tabs.ant-tabs-card > .ant-tabs-nav .ant-tabs-tab {
  flex: 1 1;
  width: auto;
  min-height: 52px;
  padding: 7px 12px !important;
  border: 2px solid transparent !important;
  border-radius: 8px !important;
}

.all-pane-center > .ant-tabs.ant-tabs-card > .ant-tabs-nav .ant-tabs-tab .ant-tabs-tab-btn {
  width: auto;
  white-space: nowrap;
  font-size: clamp(16px, 1.45vw, 19px);
}

.all-pane-center > .ant-tabs > .ant-tabs-nav .ant-tabs-tab:nth-of-type(1),
.all-pane-center > .ant-tabs > .ant-tabs-nav .ant-tabs-tab:nth-of-type(2) {
  color: #d7e3ec !important;
  background: #29465e !important;
}

.all-pane-center > .ant-tabs > .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab-active:nth-of-type(1) {
  color: #0b4d82 !important;
  background: #fff !important;
  border-color: #4da8ee !important;
  box-shadow: none;
}

.all-pane-center > .ant-tabs > .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab-active:nth-of-type(2) {
  color: #66308b !important;
  background: #fff !important;
  border-color: #b786d5 !important;
  box-shadow: none;
}

.all-pane-center > .ant-tabs > .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
  color: inherit !important;
  text-shadow: none;
}

.all-pane-center > .ant-tabs > .ant-tabs-content-holder,
.all-pane-center > .ant-tabs:has(> .ant-tabs-nav .ant-tabs-tab-active:nth-of-type(1)) > .ant-tabs-content-holder,
.all-pane-center > .ant-tabs:has(> .ant-tabs-nav .ant-tabs-tab-active:nth-of-type(2)) > .ant-tabs-content-holder {
  flex: 1 1 auto;
  min-width: 0;
  min-height: 0;
  padding: 8px;
  border: 0;
  background: #eef2f5;
}

/* Family members occupy their own stable column instead of a moving strip. */
.bank-tab-allinone {
  display: grid;
  grid-template-columns: clamp(152px, 18vw, 215px) minmax(0, 1fr);
  grid-template-rows: minmax(0, 1fr);
  gap: 8px;
  min-height: 0;
}

.bank-header {
  grid-column: 1;
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  flex-wrap: nowrap;
  gap: 8px;
  padding: 12px 9px;
  border-radius: 8px;
  background: #fff;
  box-shadow: inset 0 0 0 1px #cad5de;
  overflow: auto;
}

.bank-header::before {
  content: "작업 대상";
  display: block;
  padding: 0 5px 3px;
  color: #52697b;
  font-size: 13px;
  font-weight: 800;
}

.bank-header .ant-segmented {
  width: 100%;
  padding: 0;
  border: 0;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
}

.bank-header .ant-segmented-group {
  display: flex;
  flex-direction: column;
  gap: 7px;
}

.bank-header .ant-segmented-item {
  flex: 0 0 auto;
  width: 100%;
  border: 1px solid #d6dfe6;
  border-radius: 7px;
  color: #334b5d;
  background: #f4f7f9;
}

.bank-header .ant-segmented-item-label {
  min-height: 50px;
  justify-content: flex-start;
  padding: 8px 10px;
  text-align: left;
  font-size: clamp(13px, 1.2vw, 16px);
}

.bank-header .ant-segmented-item-selected {
  color: #073d68;
  border-color: #1976d2;
  background: #dceeff;
  box-shadow: inset 5px 0 0 #1976d2;
}

.bank-tab-allinone > .ant-tabs {
  grid-column: 2;
  min-width: 0;
}

/* Transactions are compact controls; the amount entry remains the primary task. */
.bank-tab-allinone > .ant-tabs > .ant-tabs-nav {
  margin: 0 0 8px !important;
  border-radius: 8px;
  box-shadow: inset 0 0 0 1px #cad5de;
}

.bank-tab-allinone > .ant-tabs > .ant-tabs-nav .ant-tabs-tab {
  min-height: 52px;
  font-size: clamp(16px, 1.45vw, 19px) !important;
}

.bank-tab-allinone .ant-tabs-extra-content .ant-space-item .ant-btn {
  min-width: 52px !important;
  width: 52px;
  height: 52px !important;
  min-height: 52px !important;
  border-radius: 7px;
  box-shadow: none;
}

.bank-pane {
  height: auto;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 0;
}

.bank-action-row {
  flex: 0 0 auto;
  min-height: 0;
  display: grid;
  grid-template-columns: minmax(150px, 0.85fr) minmax(220px, 1.15fr);
  grid-template-rows: 74px;
  gap: 8px;
}

.bank-balance-card,
.bank-pane > .bank-balance-card {
  flex: 0 0 74px;
  width: 100% !important;
  height: 74px;
  min-height: 74px;
  padding: 9px 14px;
  border: 1px solid #dfb64b;
  border-radius: 8px;
  background: #fff3c9;
  box-shadow: none;
}

.bank-balance-value {
  font-size: clamp(24px, 2.2vw, 31px);
}

.bank-full-exchange-btn {
  height: 74px !important;
  min-height: 74px;
  border-radius: 8px !important;
  font-size: clamp(16px, 1.4vw, 19px) !important;
}

.bank-input-card {
  flex: 1 1 auto;
  width: 100%;
  height: auto;
  min-height: 0;
  padding: 12px;
  gap: 8px;
  border: 1px solid #cad5de;
  border-radius: 8px;
  box-shadow: none;
}

.bank-amount-display {
  min-height: 86px;
  max-height: none;
  padding: 10px;
  border-width: 2px;
  border-radius: 8px;
}

.bank-amount-value {
  font-size: clamp(32px, 3vw, 42px);
}

.bank-input-card > .ant-btn,
.bank-pane > .ant-btn {
  flex: 0 0 58px;
  height: 58px !important;
  min-height: 58px !important;
  border-radius: 8px !important;
  font-size: clamp(16px, 1.4vw, 19px) !important;
}

.bank-pane > .ant-alert {
  flex: 0 0 auto;
  width: 100%;
  height: auto;
  min-height: 74px;
  padding: 12px 14px;
  border: 1px solid #e6c66a;
  border-radius: 8px;
}

@media (orientation: landscape) and (max-height: 700px) {
  .all-pane-center > .ant-tabs {
    display: flex;
  }

  .all-pane-center > .ant-tabs > .ant-tabs-nav {
    width: auto;
    height: auto;
    padding: 7px;
  }

  .all-pane-center > .ant-tabs.ant-tabs-card > .ant-tabs-nav .ant-tabs-tab {
    min-height: 48px;
  }

  .all-pane-center > .ant-tabs > .ant-tabs-content-holder,
  .all-pane-center > .ant-tabs:has(> .ant-tabs-nav .ant-tabs-tab-active:nth-of-type(1)) > .ant-tabs-content-holder,
  .all-pane-center > .ant-tabs:has(> .ant-tabs-nav .ant-tabs-tab-active:nth-of-type(2)) > .ant-tabs-content-holder {
    padding: 7px;
  }

  .bank-tab-allinone {
    grid-template-columns: clamp(145px, 18vw, 190px) minmax(0, 1fr);
    gap: 7px;
  }

  .bank-header {
    padding: 9px 7px;
  }

  .bank-header .ant-segmented-item-label {
    min-height: 44px;
    padding: 6px 8px;
  }

  .bank-tab-allinone > .ant-tabs > .ant-tabs-nav .ant-tabs-tab,
  .bank-tab-allinone .ant-tabs-extra-content .ant-space-item .ant-btn {
    min-height: 48px !important;
    height: 48px !important;
  }

  .bank-tab-allinone .ant-tabs-extra-content .ant-space-item .ant-btn {
    width: 48px;
    min-width: 48px !important;
  }

  .bank-action-row {
    grid-template-rows: 66px;
  }

  .bank-balance-card,
  .bank-pane > .bank-balance-card,
  .bank-full-exchange-btn {
    flex-basis: 66px;
    height: 66px !important;
    min-height: 66px;
  }

  .bank-input-card {
    padding: 10px;
  }

  .bank-amount-display {
    min-height: 76px;
  }

  .bank-input-card > .ant-btn,
  .bank-pane > .ant-btn {
    flex-basis: 54px;
    height: 54px !important;
    min-height: 54px !important;
  }
}

@media (max-width: 760px) {
  .bank-tab-allinone {
    grid-template-columns: 1fr;
    grid-template-rows: auto minmax(0, 1fr);
  }

  .bank-header {
    grid-column: 1;
    max-height: none;
  }

  .bank-header::before {
    display: none;
  }

  .bank-header .ant-segmented-group {
    flex-direction: row;
  }

  .bank-tab-allinone > .ant-tabs {
    grid-column: 1;
  }
}

/* v2 detail corrections from 1000x600 device review */
.all-pane-left .pane-title,
.all-pane-center > .ant-tabs > .ant-tabs-nav {
  box-sizing: border-box;
  min-height: 62px;
}

.all-pane-left .pane-title {
  display: flex;
  align-items: center;
}

.all-pane-center > .ant-tabs > .ant-tabs-content-holder .ant-empty-normal {
  width: 100%;
  height: 100%;
  min-height: 260px;
  margin: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transform: translateY(-18px);
}

.all-pane-center > .ant-tabs > .ant-tabs-content-holder .ant-empty-description {
  font-size: 0;
}

.all-pane-center > .ant-tabs > .ant-tabs-content-holder .ant-empty-description::after {
  content: "회원을 검색해 주세요";
  color: #607586;
  font-size: 15px;
  font-weight: 600;
}

.all-in-one-page .phone-submit .anticon {
  display: none;
}

.all-in-one-page .phone-submit {
  gap: 0;
  letter-spacing: 0.02em;
}

.bank-tab-allinone {
  position: relative;
}

.bank-tab-allinone > .ant-tabs {
  grid-column: 2;
  grid-row: 1;
}

.bank-header {
  position: relative;
  grid-column: 1;
  grid-row: 1;
  overflow: hidden;
}

.bank-header .ant-segmented {
  flex: 1 1 auto;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  scrollbar-gutter: stable;
}

.bank-header > .ant-typography {
  width: 100%;
  min-height: 50px;
  margin: 0 !important;
  padding: 11px 10px;
  border: 1px solid #1976d2;
  border-radius: 7px;
  color: #073d68;
  background: #dceeff;
  box-shadow: inset 5px 0 0 #1976d2;
  font-size: clamp(14px, 1.3vw, 17px);
}

/* Passport ownership is metadata, not another grid column. */
.bank-tab-allinone:has(> .bank-header + .ant-tag) > .bank-header {
  padding-top: 70px;
}

.bank-tab-allinone:has(> .bank-header + .ant-tag) > .bank-header::before {
  position: absolute;
  top: 12px;
  left: 14px;
}

.bank-tab-allinone > .bank-header + .ant-tag {
  position: absolute;
  z-index: 2;
  top: 40px;
  left: 9px;
  width: calc(clamp(152px, 18vw, 215px) - 18px);
  height: 25px;
  margin: 0 !important;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 23px;
}

/* One neutral color system for transaction choices. */
.bank-tab-allinone .ant-tabs-nav .ant-tabs-tab:nth-of-type(1),
.bank-tab-allinone .ant-tabs-nav .ant-tabs-tab:nth-of-type(2),
.bank-tab-allinone .ant-tabs-nav .ant-tabs-tab:nth-of-type(3) {
  color: #40576a !important;
  background: #e7edf2 !important;
}

.bank-tab-allinone .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab-active:nth-of-type(1),
.bank-tab-allinone .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab-active:nth-of-type(2),
.bank-tab-allinone .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab-active:nth-of-type(3) {
  color: #fff !important;
  background: #1769aa !important;
  box-shadow: inset 0 -4px 0 #0d4673;
}

.bank-tab-allinone .ant-tabs-extra-content {
  margin-left: 8px;
  padding-left: 8px;
  border-left: 1px solid #bdc9d2;
}

.bank-tab-allinone .ant-tabs-extra-content .ant-space-item:first-child .ant-btn,
.bank-tab-allinone .ant-tabs-extra-content .ant-space-item:last-child .ant-btn {
  color: #344e62;
  border-color: #b9c6d0;
  background: #f7f9fa;
}

/* Full and partial exchange are presented inside one operation card. */
.bank-pane:has(> .bank-action-row) {
  padding: 10px;
  border: 1px solid #c8d3dc;
  border-radius: 8px;
  background: #fff;
}

.bank-pane:has(> .bank-action-row) .bank-input-card {
  padding: 10px 0 0;
  border: 0;
  border-top: 1px solid #d8e0e6;
  border-radius: 0;
}

.bank-pane:has(> .bank-action-row) .bank-input-card > .ant-typography:first-child {
  color: #21394c;
  font-size: 15px;
}

.bank-input-card .ant-alert {
  border-radius: 6px;
  font-size: 14px;
  font-weight: 700;
}

/* Amount controls should look like inputs, not decorative banners. */
.bank-amount-display {
  border: 2px solid #8fa4b4;
  background: #f8fafb;
}

.bank-amount-display:hover:not(:disabled),
.bank-amount-display:active:not(:disabled) {
  border-color: #1769aa;
  background: #edf6fd;
  box-shadow: none;
}

.bank-amount-value,
.bank-amount-unit {
  color: #123f62;
}

.bank-amount-hint {
  color: #52697b;
}

@media (orientation: landscape) and (max-height: 700px) {
  .all-pane-left .pane-title,
  .all-pane-center > .ant-tabs > .ant-tabs-nav {
    min-height: 62px;
  }

  .bank-tab-allinone:has(> .bank-header + .ant-tag) > .bank-header {
    padding-top: 64px;
  }

  .bank-tab-allinone:has(> .bank-header + .ant-tag) > .bank-header::before {
    top: 9px;
    left: 12px;
  }

  .bank-tab-allinone > .bank-header + .ant-tag {
    top: 37px;
    left: 7px;
    width: calc(clamp(145px, 18vw, 190px) - 14px);
  }
}

/* Device-review corrections: exact icon removal and true empty-state centering. */
.all-in-one-page .phone-submit {
  font-size: 0 !important;
}

.all-in-one-page .phone-submit::after {
  content: "조회";
  font-size: 16px;
  font-weight: 800;
}

.all-pane-center > .ant-tabs > .ant-tabs-content-holder:has(.ant-empty) {
  position: relative;
  overflow: hidden;
}

.all-pane-center > .ant-tabs > .ant-tabs-content-holder:has(.ant-empty) > .ant-tabs-content,
.all-pane-center > .ant-tabs > .ant-tabs-content-holder:has(.ant-empty) .ant-tabs-tabpane-active,
.all-pane-center > .ant-tabs > .ant-tabs-content-holder:has(.ant-empty) .tab-pane {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100% !important;
  min-height: 100%;
}

.all-pane-center > .ant-tabs > .ant-tabs-content-holder:has(.ant-empty) .tab-pane {
  display: flex;
  align-items: center;
  justify-content: center;
}

.all-pane-center > .ant-tabs > .ant-tabs-content-holder:has(.ant-empty) .ant-empty-normal {
  width: min(420px, 78%);
  height: auto;
  min-height: 0;
  margin: 0;
  padding: 28px;
  transform: none;
}

/* Selected operator target must be unmistakable at a glance. */
.bank-header .ant-segmented-item-selected {
  color: #fff !important;
  border: 2px solid #073e69 !important;
  background: #1769aa !important;
  box-shadow: inset 6px 0 0 #082f4b, 0 0 0 2px #acd8f7 !important;
}

.bank-header .ant-segmented-item-selected .ant-segmented-item-label {
  color: #fff !important;
  font-weight: 800;
}

.bank-header > .ant-typography {
  color: #fff !important;
  border: 2px solid #073e69;
  background: #1769aa;
  box-shadow: inset 6px 0 0 #082f4b, 0 0 0 2px #acd8f7;
}

/* Exchange is one operation: balance above, equal full/partial choices below. */
.bank-pane:has(> .bank-action-row) {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  grid-template-rows: 68px 104px auto;
  align-content: start;
  gap: 8px;
  padding: 10px;
}

.bank-pane:has(> .bank-action-row) > .bank-action-row,
.bank-pane:has(> .bank-action-row) > .bank-input-card {
  display: contents;
}

.bank-pane:has(> .bank-action-row) .bank-balance-card {
  grid-column: 1 / -1;
  grid-row: 1;
  width: 100% !important;
  height: 68px;
  min-height: 68px;
}

.bank-pane:has(> .bank-action-row) .bank-full-exchange-btn {
  grid-column: 1;
  grid-row: 2;
  align-self: stretch;
  width: 100%;
  height: 104px !important;
  min-height: 104px;
  border-radius: 8px !important;
}

.bank-pane:has(> .bank-action-row) .bank-input-card > .ant-typography:first-child {
  display: none;
}

.bank-pane:has(> .bank-action-row) .bank-amount-display {
  grid-column: 2;
  grid-row: 2;
  align-self: stretch;
  width: 100%;
  height: 104px;
  min-height: 104px;
}

.bank-pane:has(> .bank-action-row) .bank-input-card > .ant-btn {
  grid-column: 2;
  grid-row: 3;
  width: 100%;
}

.bank-pane:has(> .bank-action-row) .bank-input-card > .ant-alert {
  grid-column: 1 / -1;
  grid-row: 4;
}

@media (orientation: landscape) and (max-height: 700px) {
  .bank-pane:has(> .bank-action-row) {
    grid-template-rows: 62px 92px auto;
  }

  .bank-pane:has(> .bank-action-row) .bank-balance-card {
    height: 62px !important;
    min-height: 62px;
  }

  .bank-pane:has(> .bank-action-row) .bank-full-exchange-btn,
  .bank-pane:has(> .bank-action-row) .bank-amount-display {
    height: 92px !important;
    min-height: 92px;
  }
}

/* Stable phone typography: 010 and entered digits share one rhythm. */
.all-in-one-page .all-pane-left .phone-display {
  grid-template-columns: max-content minmax(0, 1fr);
  column-gap: 9px;
}

.all-in-one-page .all-pane-left .phone-prefix,
.all-in-one-page .all-pane-left .phone-digits > span {
  width: auto;
  font-size: 20px;
  font-weight: 700;
  line-height: 1;
  font-variant-numeric: tabular-nums;
}

.all-in-one-page .all-pane-left .phone-digits {
  grid-template-columns: repeat(8, 1ch);
  justify-content: start;
  width: auto;
  column-gap: clamp(5px, 0.7vw, 8px);
}

/* Passport metadata must never move the target heading or member list. */
.bank-header,
.bank-tab-allinone:has(> .bank-header + .ant-tag) > .bank-header {
  padding: 68px 9px 9px;
}

.bank-header::before,
.bank-tab-allinone:has(> .bank-header + .ant-tag) > .bank-header::before {
  position: absolute;
  top: 12px;
  left: 14px;
}

.bank-tab-allinone > .bank-header + .ant-tag {
  top: 38px;
}

/* Disable AntD's moving layer; use the checked radio as the durable source of truth. */
.bank-header .ant-segmented-thumb {
  display: none !important;
}

.bank-header .ant-segmented-item:has(input:checked),
.bank-header .ant-segmented-item-selected {
  color: #fff !important;
  border: 2px solid #073e69 !important;
  background: #1769aa !important;
  box-shadow: inset 6px 0 0 #082f4b, 0 0 0 2px #acd8f7 !important;
}

.bank-header .ant-segmented-item:has(input:checked) .ant-segmented-item-label,
.bank-header .ant-segmented-item-selected .ant-segmented-item-label {
  color: #fff !important;
  font-weight: 800;
}

/* All three transactions use the same visual coordinates.
   Row 1: status/context, row 2: amount, row 3: execute, row 4: calculation/help. */
.bank-pane,
.bank-pane:has(> .bank-action-row) {
  min-height: 100%;
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  grid-template-rows: 68px 92px 54px auto;
  align-content: start;
  gap: 8px;
  padding: 10px;
  border: 1px solid #c8d3dc;
  border-radius: 8px;
  background: #fff;
}

.bank-pane > .bank-action-row {
  grid-column: 1;
  grid-row: 1;
  min-width: 0;
  min-height: 0;
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  grid-template-rows: 68px;
  gap: 8px;
}

.bank-pane > .bank-action-row .bank-balance-card,
.bank-pane > .bank-action-row .bank-full-exchange-btn {
  width: 100% !important;
  height: 68px !important;
  min-height: 68px;
}

.bank-pane > .bank-balance-card,
.bank-pane > .ant-alert {
  grid-column: 1;
  grid-row: 1;
  width: 100% !important;
  height: 68px;
  min-height: 68px;
}

.bank-pane > .bank-input-card,
.bank-pane:has(> .bank-action-row) > .bank-input-card {
  display: contents;
}

.bank-pane .bank-input-card > .ant-typography:first-child {
  display: none;
}

.bank-pane .bank-amount-display,
.bank-pane:has(> .bank-action-row) .bank-amount-display {
  grid-column: 1;
  grid-row: 2;
  width: 100%;
  height: 92px !important;
  min-height: 92px;
}

.bank-pane .bank-input-card > .ant-btn,
.bank-pane:has(> .bank-action-row) .bank-input-card > .ant-btn {
  grid-column: 1;
  grid-row: 3;
  width: 100%;
  height: 54px !important;
  min-height: 54px !important;
}

.bank-pane .bank-input-card > .ant-alert,
.bank-pane:has(> .bank-action-row) .bank-input-card > .ant-alert {
  grid-column: 1;
  grid-row: 4;
  width: 100%;
}

@media (orientation: landscape) and (max-height: 700px) {
  .bank-header,
  .bank-tab-allinone:has(> .bank-header + .ant-tag) > .bank-header {
    padding: 62px 7px 7px;
  }

  .bank-header::before,
  .bank-tab-allinone:has(> .bank-header + .ant-tag) > .bank-header::before {
    top: 9px;
    left: 12px;
  }

  .bank-tab-allinone > .bank-header + .ant-tag {
    top: 34px;
  }

  .bank-pane,
  .bank-pane:has(> .bank-action-row) {
    grid-template-rows: 62px 82px 50px auto;
  }

  .bank-pane > .bank-action-row {
    grid-template-rows: 62px;
  }

  .bank-pane > .bank-action-row .bank-balance-card,
  .bank-pane > .bank-action-row .bank-full-exchange-btn,
  .bank-pane > .bank-balance-card,
  .bank-pane > .ant-alert {
    height: 62px !important;
    min-height: 62px;
  }

  .bank-pane .bank-amount-display,
  .bank-pane:has(> .bank-action-row) .bank-amount-display {
    height: 82px !important;
    min-height: 82px;
  }

  .bank-pane .bank-input-card > .ant-btn,
  .bank-pane:has(> .bank-action-row) .bank-input-card > .ant-btn {
    height: 50px !important;
    min-height: 50px !important;
  }
}

/* Robust two-block transaction layout: context above, action card below. */
.bank-pane,
.bank-pane:has(> .bank-action-row) {
  min-height: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  grid-template-rows: minmax(84px, auto) minmax(0, 1fr);
  align-content: stretch;
  gap: 8px;
  padding: 10px;
  overflow: hidden;
}

.bank-pane > .bank-action-row {
  grid-column: 1;
  grid-row: 1;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  grid-template-rows: minmax(84px, auto);
  gap: 8px;
}

.bank-pane > .bank-action-row .bank-balance-card,
.bank-pane > .bank-action-row .bank-full-exchange-btn,
.bank-pane > .bank-balance-card,
.bank-pane > .ant-alert {
  width: 100% !important;
  height: auto !important;
  min-height: 84px;
  max-height: none;
}

.bank-pane > .bank-balance-card,
.bank-pane > .ant-alert {
  grid-column: 1;
  grid-row: 1;
}

.bank-pane > .bank-input-card,
.bank-pane:has(> .bank-action-row) > .bank-input-card {
  grid-column: 1;
  grid-row: 2;
  min-width: 0;
  min-height: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px;
  border: 1px solid #c8d3dc;
  border-radius: 8px;
  background: #fff;
}

.bank-pane .bank-input-card > .ant-typography:first-child,
.bank-pane:has(> .bank-action-row) .bank-input-card > .ant-typography:first-child {
  display: block;
  flex: 0 0 auto;
  color: #21394c;
  font-size: 16px;
  font-weight: 800;
}

.bank-pane .bank-amount-display,
.bank-pane:has(> .bank-action-row) .bank-amount-display {
  flex: 1 1 auto;
  width: 100%;
  height: auto !important;
  min-height: 88px;
}

.bank-pane .bank-input-card > .ant-btn,
.bank-pane:has(> .bank-action-row) .bank-input-card > .ant-btn {
  flex: 0 0 54px;
  width: 100%;
  height: 54px !important;
  min-height: 54px !important;
}

.bank-pane .bank-input-card > .ant-alert,
.bank-pane:has(> .bank-action-row) .bank-input-card > .ant-alert {
  flex: 0 0 auto;
  width: 100%;
}

/* History and refresh belong directly to the transaction bar. */
.bank-tab-allinone .ant-tabs-extra-content {
  margin-left: 4px;
  padding-left: 0;
  border-left: 0;
}

.bank-tab-allinone .ant-tabs-extra-content .ant-space {
  gap: 2px !important;
  padding: 0 !important;
}

.bank-tab-allinone .ant-tabs-extra-content .ant-space-item:first-child .ant-btn,
.bank-tab-allinone .ant-tabs-extra-content .ant-space-item:last-child .ant-btn {
  color: #344e62;
  border-color: transparent;
  background: transparent;
}

.bank-tab-allinone .ant-tabs-extra-content .ant-space-item .ant-btn:active {
  color: #0d5c96;
  background: #d9e7f1;
}

/* Denser, more legible target list; only the list itself scrolls. */
.bank-header::before {
  color: #21394c;
  font-size: 16px;
  font-weight: 900;
}

.bank-header .ant-segmented-group {
  align-content: start;
}

.bank-header .ant-segmented-item {
  flex: 0 0 62px;
  min-height: 62px;
}

.bank-header .ant-segmented-item-label {
  min-height: 58px;
  padding: 9px 10px;
  font-size: clamp(15px, 1.35vw, 17px);
  font-weight: 700;
  line-height: 1.3;
}

.bank-header > .ant-typography {
  min-height: 62px;
  padding: 15px 11px;
  font-size: clamp(16px, 1.4vw, 18px);
  font-weight: 800;
}

@media (orientation: landscape) and (max-height: 700px) {
  .bank-pane,
  .bank-pane:has(> .bank-action-row) {
    grid-template-rows: minmax(76px, auto) minmax(0, 1fr);
    padding: 8px;
  }

  .bank-pane > .bank-action-row {
    grid-template-rows: minmax(76px, auto);
  }

  .bank-pane > .bank-action-row .bank-balance-card,
  .bank-pane > .bank-action-row .bank-full-exchange-btn,
  .bank-pane > .bank-balance-card,
  .bank-pane > .ant-alert {
    height: auto !important;
    min-height: 76px;
  }

  .bank-pane > .bank-input-card,
  .bank-pane:has(> .bank-action-row) > .bank-input-card {
    padding: 10px;
  }

  .bank-pane .bank-input-card > .ant-btn,
  .bank-pane:has(> .bank-action-row) .bank-input-card > .ant-btn {
    flex-basis: 50px;
    height: 50px !important;
    min-height: 50px !important;
  }

  .bank-header .ant-segmented-item {
    flex-basis: 58px;
    min-height: 58px;
  }

  .bank-header .ant-segmented-item-label {
    min-height: 54px;
    padding: 7px 9px;
  }
}

/* Wide-screen restraint: controls keep task-sized proportions and leave calm space. */
.bank-pane,
.bank-pane:has(> .bank-action-row) {
  width: min(100%, 960px);
  height: auto;
  min-height: 0;
  grid-template-rows: minmax(76px, auto) auto;
  align-self: start;
  overflow: visible;
  background: transparent;
}

.bank-pane > .bank-action-row {
  grid-template-rows: minmax(76px, auto);
}

.bank-pane > .bank-action-row .bank-balance-card,
.bank-pane > .bank-action-row .bank-full-exchange-btn,
.bank-pane > .bank-balance-card,
.bank-pane > .ant-alert {
  min-height: 76px;
}

.bank-pane > .bank-input-card,
.bank-pane:has(> .bank-action-row) > .bank-input-card {
  height: auto;
  min-height: 176px;
  max-height: none;
}

.bank-pane .bank-amount-display,
.bank-pane:has(> .bank-action-row) .bank-amount-display {
  flex: 0 0 92px;
  height: 92px !important;
  min-height: 92px;
}

.bank-pane .bank-input-card > .ant-btn,
.bank-pane:has(> .bank-action-row) .bank-input-card > .ant-btn {
  flex: 0 0 52px;
  height: 52px !important;
  min-height: 52px !important;
}

/* Member card contents: identity first, passport status always on its owner. */
.bank-header .ant-segmented-group {
  height: auto !important;
  justify-content: flex-start !important;
  align-items: stretch;
}

.bank-header .ant-segmented-item {
  flex: 0 0 auto !important;
  height: auto !important;
  min-height: 68px;
  max-height: none;
}

.bank-header .ant-segmented-item-label {
  min-height: 66px;
  padding: 9px 10px;
}

.bank-member-option {
  width: 100%;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 5px;
  text-align: left;
}

.bank-member-summary {
  width: 100%;
  min-width: 0;
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 7px;
}

.bank-member-name {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: inherit;
  font-size: 15px;
  font-weight: 800;
}

.bank-member-balance {
  flex: 0 0 auto;
  color: inherit;
  font-size: 14px;
  font-weight: 800;
  font-variant-numeric: tabular-nums;
}

.bank-member-passport {
  display: inline-flex;
  align-items: center;
  min-height: 20px;
  padding: 2px 7px;
  border-radius: 4px;
  color: #63308c;
  background: #f0e4f8;
  font-size: 12px;
  font-weight: 800;
  line-height: 1.2;
}

.bank-header .ant-segmented-item:has(input:checked) .bank-member-passport,
.bank-header .ant-segmented-item-selected .bank-member-passport,
.bank-header > .ant-typography .bank-member-passport {
  color: #fff;
  background: rgba(255, 255, 255, 0.22);
}

/* The old selected-member passport strip is no longer rendered. */
.bank-tab-allinone > .bank-header + .ant-tag {
  display: none;
}

.bank-header,
.bank-tab-allinone:has(> .bank-header + .ant-tag) > .bank-header {
  padding: 44px 9px 9px;
}

/* Search and service selectors share one larger tablet touch row. */
.all-pane-left .pane-title.member-search-title,
.all-pane-center > .ant-tabs > .ant-tabs-nav {
  box-sizing: border-box;
  height: 84px;
  min-height: 84px;
}

.all-pane-left .pane-title.member-search-title {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 3px;
  padding: 10px 16px;
}

.member-search-title-main {
  font-size: clamp(17px, 1.45vw, 19px);
  font-weight: 900;
  line-height: 1.2;
}

.member-search-title-help {
  color: #c9d8e3;
  font-size: clamp(12px, 1vw, 13px);
  font-weight: 600;
  line-height: 1.2;
}

.all-pane-center > .ant-tabs > .ant-tabs-nav {
  padding-block: 7px;
}

.all-pane-center > .ant-tabs.ant-tabs-card > .ant-tabs-nav .ant-tabs-tab {
  height: 70px;
  min-height: 70px;
  align-items: center;
  justify-content: center;
}

@media (orientation: landscape) and (max-height: 700px) {
  .bank-pane,
  .bank-pane:has(> .bank-action-row) {
    grid-template-rows: minmax(70px, auto) auto;
  }

  .bank-pane > .bank-action-row {
    grid-template-rows: minmax(70px, auto);
  }

  .bank-pane > .bank-action-row .bank-balance-card,
  .bank-pane > .bank-action-row .bank-full-exchange-btn,
  .bank-pane > .bank-balance-card,
  .bank-pane > .ant-alert {
    min-height: 70px;
  }

  .bank-pane > .bank-input-card,
  .bank-pane:has(> .bank-action-row) > .bank-input-card {
    min-height: 164px;
  }

  .bank-pane .bank-amount-display,
  .bank-pane:has(> .bank-action-row) .bank-amount-display {
    flex-basis: 84px;
    height: 84px !important;
    min-height: 84px;
  }

  .bank-header,
  .bank-tab-allinone:has(> .bank-header + .ant-tag) > .bank-header {
    padding: 40px 7px 7px;
  }
}

/* Phone entry uses the complete field width without changing digit typography. */
.all-in-one-page .all-pane-left .phone-display {
  grid-template-columns: 44px minmax(0, 1fr);
  column-gap: 3px;
}

.all-in-one-page .all-pane-left .phone-prefix {
  width: 44px;
}

.all-in-one-page .all-pane-left .phone-digits {
  width: 100%;
  grid-template-columns: repeat(8, minmax(0, 1fr));
  column-gap: 0;
}

/* Explicitly reset obsolete grid coordinates that caused exchange controls to overlap. */
.bank-pane:has(> .bank-action-row) > .bank-action-row {
  position: relative;
  z-index: 1;
  grid-column: 1;
  grid-row: 1;
  width: 100%;
  height: 76px;
  min-height: 76px;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  grid-template-rows: 76px;
  gap: 12px;
  overflow: visible;
}

.bank-pane:has(> .bank-action-row) > .bank-action-row > .bank-balance-card {
  grid-column: 1 !important;
  grid-row: 1 !important;
  width: 100% !important;
  height: 76px !important;
  min-height: 76px;
}

.bank-pane:has(> .bank-action-row) > .bank-action-row > .bank-full-exchange-btn {
  grid-column: 2 !important;
  grid-row: 1 !important;
  align-self: stretch;
  width: 100% !important;
  height: 76px !important;
  min-height: 76px;
  margin: 0 !important;
}

.bank-pane:has(> .bank-action-row) > .bank-input-card {
  position: relative;
  z-index: 1;
  grid-column: 1;
  grid-row: 2;
  margin-top: 4px;
  border: 1px solid #c8d3dc;
  background: #fff;
}

.bank-pane:has(> .bank-action-row) > .bank-input-card .bank-amount-display,
.bank-pane:has(> .bank-action-row) > .bank-input-card > .ant-btn,
.bank-pane:has(> .bank-action-row) > .bank-input-card > .ant-alert {
  position: static;
  grid-column: auto;
  grid-row: auto;
  margin: 0;
}

@media (orientation: landscape) and (max-height: 700px) {
  .bank-pane:has(> .bank-action-row) > .bank-action-row {
    height: 70px;
    min-height: 70px;
    grid-template-rows: 70px;
  }

  .bank-pane:has(> .bank-action-row) > .bank-action-row > .bank-balance-card,
  .bank-pane:has(> .bank-action-row) > .bank-action-row > .bank-full-exchange-btn {
    height: 70px !important;
    min-height: 70px;
  }
}

/* Exchange variants: equal-height sibling cards, without filling the workspace. */
.bank-pane:has(> .bank-action-row) {
  width: min(100%, 960px);
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  grid-template-rows: 220px;
  align-items: stretch;
  gap: 12px;
  padding: 0;
  border: 0;
  background: transparent;
  overflow: visible;
}

.bank-pane:has(> .bank-action-row) > .bank-action-row {
  grid-column: 1;
  grid-row: 1;
  width: 100%;
  height: 220px;
  min-height: 220px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px;
  border: 1px solid #c8d3dc;
  border-radius: 8px;
  background: #fff;
}

.bank-pane:has(> .bank-action-row) > .bank-action-row::before {
  content: "전량 인출";
  flex: 0 0 auto;
  color: #21394c;
  font-size: 16px;
  font-weight: 800;
  line-height: 1.4;
}

.bank-pane:has(> .bank-action-row) > .bank-action-row > .bank-balance-card {
  flex: 1 1 auto;
  width: 100% !important;
  height: auto !important;
  min-height: 76px;
}

.bank-pane:has(> .bank-action-row) > .bank-action-row > .bank-full-exchange-btn {
  flex: 0 0 52px;
  width: 100% !important;
  height: 52px !important;
  min-height: 52px;
}

.bank-pane:has(> .bank-action-row) > .bank-input-card {
  grid-column: 2;
  grid-row: 1;
  width: 100%;
  height: 220px;
  min-height: 220px;
  margin: 0;
  padding: 12px;
  border: 1px solid #c8d3dc;
  border-radius: 8px;
  background: #fff;
}

.bank-pane:has(> .bank-action-row) > .bank-input-card .bank-amount-display {
  flex: 1 1 auto;
  height: auto !important;
  min-height: 76px;
}

.bank-pane:has(> .bank-action-row) > .bank-input-card > .ant-btn {
  flex: 0 0 52px;
  height: 52px !important;
  min-height: 52px !important;
}

@media (orientation: landscape) and (max-height: 700px) {
  .bank-pane:has(> .bank-action-row) {
    grid-template-rows: 204px;
  }

  .bank-pane:has(> .bank-action-row) > .bank-action-row,
  .bank-pane:has(> .bank-action-row) > .bank-input-card {
    height: 204px;
    min-height: 204px;
    padding: 10px;
  }

  .bank-pane:has(> .bank-action-row) > .bank-action-row > .bank-full-exchange-btn,
  .bank-pane:has(> .bank-action-row) > .bank-input-card > .ant-btn {
    flex-basis: 48px;
    height: 48px !important;
    min-height: 48px !important;
  }
}

/* Exchange cards grow together when the remaining-balance notice appears. */
.bank-pane:has(> .bank-action-row) {
  grid-template-rows: minmax(220px, auto);
  align-items: stretch;
}

.bank-pane:has(> .bank-action-row) > .bank-action-row,
.bank-pane:has(> .bank-action-row) > .bank-input-card {
  height: auto;
  min-height: 220px;
  align-self: stretch;
}

/* Donation stays identifiable while disabled; opacity alone communicates state. */
.bank-tab-allinone button[data-testid="btn-bank-donate"],
.bank-tab-allinone button[data-testid="btn-bank-donate"]:disabled {
  color: #fff !important;
  border-color: #c2185b !important;
  background: #c2185b !important;
}

.bank-tab-allinone button[data-testid="btn-bank-donate"]:disabled {
  opacity: 0.55;
}

@media (orientation: landscape) and (max-height: 700px) {
  .bank-pane:has(> .bank-action-row) {
    grid-template-rows: minmax(204px, auto);
  }

  .bank-pane:has(> .bank-action-row) > .bank-action-row,
  .bank-pane:has(> .bank-action-row) > .bank-input-card {
    height: auto;
    min-height: 204px;
  }
}

/* Final readability pass for the target selector. */
.bank-header::before {
  font-size: 18px;
  line-height: 1.3;
}

.bank-member-name {
  font-size: clamp(16px, 1.45vw, 18px);
  line-height: 1.35;
  font-weight: 900;
}
`, "",{"version":3,"sources":["webpack://./src/pages/AllInOnePage.css"],"names":[],"mappings":"AAAA,8BAA8B;;AAE9B;uDACuD;AACvD;;;;;;;;EAQE,wBAAwB;EACxB,uBAAuB;EACvB,4BAA4B;EAC5B,0BAA0B;EAC1B,iCAAiC;AACnC;AACA;EACE,4BAA4B;AAC9B;;AAEA,uEAAuE;AACvE;;;;;;;EAOE,wBAAwB;AAC1B;AACA;;EAEE,uBAAuB;AACzB;AACA;EACE,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,uCAAuC;EACvC,kBAAkB;AACpB;;AAEA,8CAA8C;AAC9C;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,uCAAuC;AACzC;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,aAAa;EACb,SAAS;EACT,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;AACrB;AACA,mBAAmB,aAAa,EAAE;AAClC,mBAAmB,aAAa,EAAE;;AAElC;EACE,cAAc;EACd,kBAAkB;EAClB,mCAAmC;EACnC,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA,yDAAyD;AACzD;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,cAAc;EACd,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,iCAAiC;EACjC,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,4CAA4C;EAC5C,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;oDACoD;AACpD;EACE,mBAAmB;EACnB,kBAAkB;EAClB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,QAAQ;AACV;;AAEA,yEAAyE;AACzE;EACE,wCAAwC;EACxC,8BAA8B;EAC9B,uCAAuC;EACvC,SAAW;EACX,uBAAuB;EACvB,oBAAoB;EACpB,gDAAgD;EAChD,kCAAkC;EAClC,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;EAClB,MAAM;AACR;AACA;EACE,oCAAoC;AACtC;;AAEA,wCAAwC;AACxC,4EAA4E,8BAA8B,EAAE,yBAAyB,EAAE;AACvI,4EAA4E,8BAA8B,EAAE,yBAAyB,EAAE;AACvI,4EAA4E,8BAA8B,EAAE,yBAAyB,EAAE;AACvI,4EAA4E,8BAA8B,EAAE,yBAAyB,EAAE;AACvI,4EAA4E,8BAA8B,EAAE,yBAAyB,EAAE;;AAEvI,+BAA+B;AAC/B,wIAAwI,8BAA8B,EAAE;AACxK,wIAAwI,8BAA8B,EAAE;AACxK,wIAAwI,8BAA8B,EAAE;AACxK,wIAAwI,8BAA8B,EAAE;AACxK,wIAAwI,8BAA8B,EAAE;;AAExK,8CAA8C;AAC9C;EACE,eAAe;EACf,yCAAyC;EACzC,2BAA2B;AAC7B;AACA;EACE,aAAa;AACf;AACA;EACE,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA,gGAAgG,8BAA8B,EAAE,sBAAsB,EAAE;AACxJ,gGAAgG,8BAA8B,EAAE,sBAAsB,EAAE;AACxJ,gGAAgG,8BAA8B,EAAE,sBAAsB,EAAE;AACxJ,gGAAgG,8BAA8B,EAAE,sBAAsB,EAAE;AACxJ,gGAAgG,8BAA8B,EAAE,sBAAsB,EAAE;;AAExJ,qCAAqC;AACrC;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA,yCAAyC;AACzC;EACE,iCAAiC;EACjC,mBAAmB;AACrB;AACA,mHAAmH,mBAAmB,EAAE,yBAAyB,EAAE;AACnK,mHAAmH,mBAAmB,EAAE,yBAAyB,EAAE;AACnK,mHAAmH,mBAAmB,EAAE,yBAAyB,EAAE;AACnK,mHAAmH,mBAAmB,EAAE,yBAAyB,EAAE;AACnK,mHAAmH,mBAAmB,EAAE,yBAAyB,EAAE;;AAEnK;EACE,cAAc;EACd,cAAc;EACd,4DAA4D;AAC9D;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iCAAiC;AACnC;;AAEA,6CAA6C;AAC7C;EACE,sBAAsB;EACtB,uCAAuC;EACvC,+BAA+B;EAC/B,0BAA0B;EAC1B,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,6CAA6C;EAC7C,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA,qDAAqD;AACrD,+DAA+D;AAC/D;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA,aAAa;AACb;EACE,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,UAAU;EACV,eAAe;EACf,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,sCAAsC;AACtC;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,0CAA0C;EAC1C,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA,uDAAuD;AACvD;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA,sDAAsD;AACtD;EACE;IACE,cAAc;IACd,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,QAAQ;IACR,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,iBAAiB;EACnB;;EAEA;;IAEE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,aAAa;IACb,6CAA6C;EAC/C;;EAEA;IACE,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,kCAAkC;IAClC,gCAAgC;IAChC,aAAa;EACf;AACF;;AAEA,yBAAyB,gBAAgB,EAAE,UAAU,EAAE,SAAS,EAAE,gBAAgB,EAAE;;AAEpF,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,4BAA4B;EAC5B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,QAAQ;AACV;;AAEA,yCAAyC;AACzC;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,kDAAkD;AACpD;;AAEA;EACE,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,mCAAmC;EACnC,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,8CAA8C;AAChD;;AAEA,wCAAwC;AACxC;;;EAGE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,0BAA0B;EAC1B,oCAAoC;AACtC;;AAEA,mDAAmD;AACnD;EACE,4BAA4B;EAC5B,WAAW;EACX,kCAAkC;EAClC,uBAAuB;EACvB,qCAAqC;EACrC,wCAAwC;EACxC,8CAA8C;EAC9C,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;AAC7B;AACA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,SAAW;AACb;AACA;EACE,2BAA2B;AAC7B;;AAEA,cAAc;AACd,gEAAgE,8BAA8B,EAAE,yBAAyB,EAAE;AAC3H,gEAAgE,8BAA8B,EAAE,yBAAyB,EAAE;AAC3H,gEAAgE,8BAA8B,EAAE,yBAAyB,EAAE;;AAE3H,iBAAiB;AACjB,gGAAgG,8BAA8B,EAAE;AAChI,gGAAgG,8BAA8B,EAAE;AAChI,gGAAgG,8BAA8B,EAAE;;AAEhI,qBAAqB;AACrB;EACE,eAAe;EACf,8CAA8C;EAC9C,2BAA2B;AAC7B;AACA;EACE,sBAAsB;EACtB,0CAA0C;AAC5C;AACA,oFAAoF,8BAA8B,EAAE;AACpH,oFAAoF,8BAA8B,EAAE;AACpH,oFAAoF,8BAA8B,EAAE;;AAEpH,iDAAiD;AACjD;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;EACf,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mEAAmE;EACnE,2BAA2B;EAC3B,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,qDAAqD;EACrD,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,8CAA8C;EAC9C,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,iCAAiC;EACjC,aAAa;EACb,sBAAsB;EACtB,0BAA0B;EAC1B,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB,0BAA0B,EAAE;AACjD;;AAEA,4BAA4B;AAC5B;EACE,gBAAgB;EAChB,qDAAqD;EACrD,0BAA0B;EAC1B,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,WAAW;EACX,kCAAkC;EAClC,cAAc;AAChB;AACA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,qBAAqB;EACrB,QAAQ;EACR,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,8CAA8C;AAChD;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,+CAA+C;EAC/C,8CAA8C;EAC9C,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA,mDAAmD;AACnD;EACE,YAAY,QAAQ,EAAE,YAAY,EAAE;EACpC,iBAAiB,qCAAqC,EAAE;EACxD,4CAA4C,kBAAkB,EAAE;EAChE,YAAY,YAAY,EAAE;EAC1B,yCAAyC,gBAAgB,EAAE,kBAAkB,EAAE;EAC/E,iDAAiD,gBAAgB,EAAE;EACnE;IACE,uBAAuB;IACvB,2BAA2B;EAC7B;EACA;;4BAE0B,gBAAgB,EAAE;EAC5C,mBAAmB,kBAAkB,EAAE;EACvC,uBAAuB,gBAAgB,EAAE,sBAAsB,EAAE;EACjE,wBAAwB,2BAA2B,EAAE;AACvD;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;AACV;;AAEA,yBAAyB;AACzB,eAAe,kBAAkB,EAAE;;AAEnC;EACE,qDAAqD;EACrD,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,QAAQ;EACR,mBAAmB;AACrB;AACA,0BAA0B,YAAY,EAAE,cAAc,EAAE;AACxD;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA,qBAAqB,eAAe,EAAE,aAAa,EAAE,QAAQ,EAAE,eAAe,EAAE;AAChF,8BAA8B,SAAS,EAAE;AACzC;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;AACA,sBAAsB,gBAAgB,EAAE;;AAExC;EACE,aAAa;EACb,wCAAwC;EACxC,QAAQ;AACV;AACA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA,qBAAqB,cAAc,EAAE;AACrC,qBAAqB,eAAe,EAAE,sBAAsB,EAAE;AAC9D;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,sBAAsB;AACtB,0BAA0B,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AAC3E;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA,uBAAuB,oBAAoB,EAAE,cAAc,EAAE;AAC7D;EACE,cAAc;EACd,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,oBAAoB;EACpB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA,2BAA2B,oBAAoB,EAAE,cAAc,EAAE;AACjE,0BAA0B,cAAc,EAAE,gBAAgB,EAAE;AAC5D,mCAAmC,eAAe,EAAE,YAAY,EAAE,wBAAwB,EAAE,yBAAyB,EAAE,4BAA4B,EAAE;AACrJ,uBAAuB,uBAAuB,EAAE,wBAAwB,EAAE,0BAA0B,EAAE,4BAA4B,EAAE,0BAA0B,EAAE;;AAEhK,+CAA+C;AAC/C;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA,iDAAiD,cAAc,EAAE;AACjE,yBAAyB,eAAe,EAAE,cAAc,EAAE;AAC1D,0BAA0B,gBAAgB,EAAE;AAC5C;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oBAAoB;AACtB;AACA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,2BAA2B;EAC3B,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;;qCAEqC;AACrC;EACE,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,kCAAkC;EAClC,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,2BAA2B;EAC3B,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;;uDAEuD;AACvD;EACE,0BAA0B;EAC1B,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,SAAS;EACT,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,6CAA6C;AAC/C;;AAEA,0DAA0D;AAC1D;EACE,aAAa;EACb,+DAA+D;EAC/D,kCAAkC;EAClC,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,SAAS;EACT,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mCAAmC;EACnC,4BAA4B;EAC5B,wCAAwC;EACxC,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,oCAAoC;EACpC,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,gCAAgC;EAChC,6CAA6C;AAC/C;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,gCAAgC;EAChC,6CAA6C;AAC/C;;AAEA;;;EAGE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,aAAa;EACb,aAAa;EACb,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA,mFAAmF;AACnF;EACE,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,2BAA2B;EAC3B,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,kCAAkC;EAClC,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,aAAa;EACb,cAAc;AAChB;;AAEA;;EAEE,YAAY;AACd;;AAEA,+EAA+E;AAC/E;EACE,YAAY;EACZ,aAAa;EACb,kEAAkE;EAClE,kCAAkC;EAClC,6BAA6B;EAC7B,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,0BAA0B;EAC1B,0DAA0D;EAC1D,SAAS;AACX;;AAEA;;EAEE,YAAY;EACZ,aAAa;EACb,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,8BAA8B;EAC9B,iCAAiC;EACjC,SAAS;EACT,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,SAAS;EACT,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE;IACE,2CAA2C;EAC7C;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;;IAGE,aAAa;EACf;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,yDAAyD;IACzD,QAAQ;EACV;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,0CAA0C;EAC5C;;EAEA;IACE,0BAA0B;IAC1B,6BAA6B;EAC/B;;EAEA;IACE,gEAAgE;IAChE,sCAAsC;EACxC;AACF;;AAEA;iEACiE;AACjE;;;EAGE,0BAA0B;EAC1B,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;EACE,QAAQ;EACR,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,yEAAyE;AACzE;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,SAAW;EACX,WAAW;EACX,gBAAgB;EAChB,4BAA4B;EAC5B,wCAAwC;EACxC,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;;EAEE,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;;;EAGE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,SAAS;EACT,mBAAmB;AACrB;;AAEA,6EAA6E;AAC7E;EACE,aAAa;EACb,+DAA+D;EAC/D,kCAAkC;EAClC,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,oBAAoB;EACpB,iBAAiB;EACjB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,iBAAiB;EACjB,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA,kFAAkF;AAClF;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;EACE,0BAA0B;EAC1B,WAAW;EACX,uBAAuB;EACvB,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,aAAa;EACb,aAAa;EACb,kEAAkE;EAClE,wBAAwB;EACxB,QAAQ;AACV;;AAEA;;EAEE,cAAc;EACd,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,6BAA6B;EAC7B,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,aAAa;EACb,QAAQ;EACR,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;;EAEE,cAAc;EACd,uBAAuB;EACvB,2BAA2B;EAC3B,6BAA6B;EAC7B,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;;IAGE,YAAY;EACd;;EAEA;IACE,+DAA+D;IAC/D,QAAQ;EACV;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;;IAEE,2BAA2B;IAC3B,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,0BAA0B;EAC5B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;;IAGE,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,gBAAgB;IAChB,uBAAuB;IACvB,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,uCAAuC;EACzC;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA,sDAAsD;AACtD;;EAEE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,MAAM;EACN,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,iCAAiC;EACjC,mCAAmC;AACrC;;AAEA,6DAA6D;AAC7D;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,SAAS;EACT,6CAA6C;EAC7C,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,sDAAsD;AACtD;;;EAGE,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;;;EAGE,sBAAsB;EACtB,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;;EAEE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,uEAAuE;AACvE;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,SAAS;EACT,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA,qEAAqE;AACrE;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;EAEE,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;;IAEE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,QAAQ;IACR,UAAU;EACZ;;EAEA;IACE,SAAS;IACT,SAAS;IACT,6CAA6C;EAC/C;AACF;;AAEA,kFAAkF;AAClF;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;;EAGE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,SAAS;EACT,aAAa;EACb,eAAe;AACjB;;AAEA,+DAA+D;AAC/D;EACE,sBAAsB;EACtB,oCAAoC;EACpC,8BAA8B;EAC9B,+DAA+D;AACjE;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,oDAAoD;AACtD;;AAEA,gFAAgF;AAChF;EACE,aAAa;EACb,gDAAgD;EAChD,mCAAmC;EACnC,oBAAoB;EACpB,QAAQ;EACR,aAAa;AACf;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,WAAW;EACX,wBAAwB;EACxB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE;IACE,kCAAkC;EACpC;;EAEA;IACE,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;;IAEE,uBAAuB;IACvB,gBAAgB;EAClB;AACF;;AAEA,sEAAsE;AACtE;EACE,iDAAiD;EACjD,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;EACrC,sBAAsB;EACtB,WAAW;EACX,kCAAkC;AACpC;;AAEA,yEAAyE;AACzE;;EAEE,qBAAqB;AACvB;;AAEA;;EAEE,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,SAAS;AACX;;AAEA,uFAAuF;AACvF;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,sBAAsB;EACtB,oCAAoC;EACpC,8BAA8B;EAC9B,+DAA+D;AACjE;;AAEA;;EAEE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;mFACmF;AACnF;;EAEE,gBAAgB;EAChB,aAAa;EACb,qCAAqC;EACrC,uCAAuC;EACvC,oBAAoB;EACpB,QAAQ;EACR,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,aAAa;EACb,oDAAoD;EACpD,wBAAwB;EACxB,QAAQ;AACV;;AAEA;;EAEE,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,WAAW;EACX,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,WAAW;EACX,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,WAAW;AACb;;AAEA;EACE;;IAEE,qBAAqB;EACvB;;EAEA;;IAEE,QAAQ;IACR,UAAU;EACZ;;EAEA;IACE,SAAS;EACX;;EAEA;;IAEE,uCAAuC;EACzC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;;;IAIE,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;;IAEE,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;;IAEE,uBAAuB;IACvB,2BAA2B;EAC7B;AACF;;AAEA,2EAA2E;AAC3E;;EAEE,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,qCAAqC;EACrC,qDAAqD;EACrD,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,aAAa;EACb,gDAAgD;EAChD,sCAAsC;EACtC,QAAQ;AACV;;AAEA;;;;EAIE,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,WAAW;AACb;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;;EAEE,cAAc;EACd,WAAW;AACb;;AAEA,gEAAgE;AAChE;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;EACd,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA,oEAAoE;AACpE;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,oCAAoC;EACpC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE;;IAEE,qDAAqD;IACrD,YAAY;EACd;;EAEA;IACE,sCAAsC;EACxC;;EAEA;;;;IAIE,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;;IAEE,aAAa;EACf;;EAEA;;IAEE,gBAAgB;IAChB,uBAAuB;IACvB,2BAA2B;EAC7B;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;AACF;;AAEA,sFAAsF;AACtF;;EAEE,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,2CAA2C;EAC3C,iBAAiB;EACjB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;;;;EAIE,gBAAgB;AAClB;;AAEA;;EAEE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA,+EAA+E;AAC/E;EACE,uBAAuB;EACvB,sCAAsC;EACtC,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;;EAGE,WAAW;EACX,qCAAqC;AACvC;;AAEA,kEAAkE;AAClE;EACE,aAAa;AACf;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA,oEAAoE;AACpE;;EAEE,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE;;IAEE,2CAA2C;EAC7C;;EAEA;IACE,sCAAsC;EACxC;;EAEA;;;;IAIE,gBAAgB;EAClB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;;IAEE,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;;IAEE,qBAAqB;EACvB;AACF;;AAEA,iFAAiF;AACjF;EACE,0CAA0C;EAC1C,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gDAAgD;EAChD,aAAa;AACf;;AAEA,yFAAyF;AACzF;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,WAAW;EACX,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,gDAAgD;EAChD,wBAAwB;EACxB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;;EAGE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,SAAS;AACX;;AAEA;EACE;IACE,YAAY;IACZ,gBAAgB;IAChB,wBAAwB;EAC1B;;EAEA;;IAEE,uBAAuB;IACvB,gBAAgB;EAClB;AACF;;AAEA,kFAAkF;AAClF;EACE,uBAAuB;EACvB,aAAa;EACb,gDAAgD;EAChD,yBAAyB;EACzB,oBAAoB;EACpB,SAAS;EACT,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE;IACE,yBAAyB;EAC3B;;EAEA;;IAEE,aAAa;IACb,iBAAiB;IACjB,aAAa;EACf;;EAEA;;IAEE,gBAAgB;IAChB,uBAAuB;IACvB,2BAA2B;EAC7B;AACF;;AAEA,4EAA4E;AAC5E;EACE,uCAAuC;EACvC,oBAAoB;AACtB;;AAEA;;EAEE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,kFAAkF;AAClF;;EAEE,sBAAsB;EACtB,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,uCAAuC;EACzC;;EAEA;;IAEE,YAAY;IACZ,iBAAiB;EACnB;AACF;;AAEA,oDAAoD;AACpD;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,iBAAiB;EACjB,gBAAgB;AAClB","sourcesContent":["/* 운영도구 - 올인원 페이지 (PR1 셸 단계) */\n\n/* App.css 전역 button 규칙(min-height:60px / font-size:20px)이 AntD pagination\n   prev/next 버튼에 적용되어 페이지 번호(<li>)와 수직 정렬이 어긋나는 문제 보정 */\n.ant-pagination .ant-pagination-prev,\n.ant-pagination .ant-pagination-next,\n.ant-pagination .ant-pagination-jump-prev,\n.ant-pagination .ant-pagination-jump-next,\n.ant-pagination .ant-pagination-prev button,\n.ant-pagination .ant-pagination-next button,\n.ant-pagination .ant-pagination-item,\n.ant-pagination .ant-pagination-options .ant-select-selector {\n  min-height: 0 !important;\n  height: 28px !important;\n  line-height: 26px !important;\n  font-size: 14px !important;\n  vertical-align: middle !important;\n}\n.ant-pagination .ant-pagination-item a {\n  line-height: 26px !important;\n}\n\n/* App.css 전역 input { min-height:60px } 가 AntD 내부 input 까지 부풀리는 문제 보정 */\n.ant-modal .ant-input,\n.ant-modal .ant-input-sm,\n.ant-modal .ant-picker,\n.ant-modal .ant-picker-small,\n.ant-modal .ant-picker-input > input,\n.ant-modal .ant-select-selector,\n.ant-modal .ant-select-selection-search-input {\n  min-height: 0 !important;\n}\n.ant-modal .ant-input-sm,\n.ant-modal .ant-picker-small {\n  height: 28px !important;\n}\n.ant-modal .ant-picker-small .ant-picker-input > input {\n  height: 26px !important;\n  font-size: 13px !important;\n}\n\n.all-in-one-page {\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  height: 100dvh;\n  background: #ECEFF1;\n  font-family: \"Noto Sans KR\", sans-serif;\n  position: relative;\n}\n\n/* 전역 API 펜딩 오버레이 — 모든 axios 요청 진행 중 인터랙션 차단 */\n.api-busy-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 9999;\n  background: rgba(38, 50, 56, 0.35);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: wait;\n  -webkit-user-select: none;\n  user-select: none;\n  touch-action: none;\n}\n.api-busy-overlay.done {\n  opacity: 0;\n  pointer-events: none;\n}\n.api-busy-card {\n  background: #fff;\n  border-radius: 14px;\n  padding: 22px 28px;\n  min-width: 240px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n  box-shadow: 0 6px 24px rgba(0,0,0,0.18);\n}\n.api-busy-text {\n  font-size: 16px;\n  font-weight: 700;\n  color: #263238;\n}\n.api-busy-sub {\n  font-size: 12px;\n  color: #607D8B;\n}\n.api-busy-check {\n  font-size: 36px;\n  line-height: 1;\n}\n.all-header {\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 16px;\n  background: #fff;\n  border-bottom: 1px solid #CFD8DC;\n  min-height: 48px;\n}\n\n.all-header-left,\n.all-header-right {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.all-header-title {\n  font-size: 18px;\n  font-weight: 600;\n  color: #263238;\n}\n\n.all-user-name {\n  font-size: 14px;\n  color: #546E7A;\n}\n\n.all-main {\n  flex: 1 1 auto;\n  display: flex;\n  min-height: 0;\n  gap: 10px;\n  padding: 10px;\n}\n\n.all-pane {\n  background: #fff;\n  border: 1px solid #D7E0E6;\n  border-radius: 14px;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  overflow: hidden;\n  box-shadow: 0 3px 12px rgba(38, 50, 56, 0.06);\n}\n\n.all-pane-left   {\n  flex: 0 0 clamp(250px, 26vw, 320px);\n  background: #FBFCFD;\n}\n.all-pane-center { flex: 1 1 50%; }\n.all-pane-right  { flex: 0 0 22%; }\n\n.pane-title {\n  flex: 0 0 auto;\n  padding: 11px 14px;\n  font-size: clamp(14px, 1.3vw, 16px);\n  font-weight: 700;\n  color: #263238;\n  background: #F2F6F8;\n  border-bottom: 2px solid #DCE5EA;\n}\n\n/* 검색은 조회 후에도 계속 사용하는 핵심 도구다. 영역을 없애지 않고 입력부의 경계를 강화한다. */\n.all-in-one-page .all-pane-left .phone-numpad {\n  padding: 12px;\n}\n\n.all-in-one-page .all-pane-left .phone-display {\n  display: grid;\n  grid-template-columns: 48px minmax(0, 1fr);\n  align-items: center;\n  gap: 8px;\n  min-height: 58px;\n  padding: 8px 10px;\n  border: 2px solid #CE93D8;\n  border-radius: 13px;\n  background: #FFFFFF;\n  box-shadow: 0 3px 9px rgba(123, 31, 162, 0.09);\n  overflow: hidden;\n}\n\n.all-in-one-page .all-pane-left .phone-prefix {\n  width: 48px;\n  color: #455A64;\n  font-size: 20px;\n  font-weight: 800;\n  line-height: 1;\n  text-align: center;\n  white-space: nowrap;\n}\n\n.all-in-one-page .all-pane-left .phone-digits {\n  display: grid;\n  grid-template-columns: repeat(8, minmax(0, 1fr));\n  align-items: center;\n  width: 100%;\n  min-width: 0;\n  gap: 1px;\n  color: #263238;\n  font-variant-numeric: tabular-nums;\n  letter-spacing: 0;\n}\n\n.all-in-one-page .all-pane-left .phone-digits > span {\n  display: block;\n  min-width: 0;\n  font-size: clamp(17px, 2vw, 22px);\n  font-weight: 700;\n  line-height: 1;\n  text-align: center;\n}\n\n.all-in-one-page .all-pane-left .phone-digits > .placeholder {\n  color: #B0BEC5;\n  font-weight: 500;\n}\n\n.all-in-one-page .all-pane-left .numpad-key {\n  border-radius: 11px;\n  border-color: #CAD5DC;\n  box-shadow: 0 2px 5px rgba(38, 50, 56, 0.08);\n  transition: none;\n}\n\n.all-in-one-page .all-pane-left .numpad-key:active:not(:disabled) {\n  border-color: #607D8B;\n  background: #DCE5EA;\n}\n\n.all-in-one-page .all-pane-left .numpad-clear {\n  color: #B42318;\n  border-color: #FDA29B;\n  background: #FFF1F0;\n}\n\n.all-in-one-page .all-pane-left .numpad-backspace {\n  color: #5E35B1;\n  border-color: #B39DDB;\n  background: #F5F0FF;\n}\n\n.all-in-one-page .all-pane-left .phone-submit {\n  border-radius: 11px;\n}\n\n.pane-placeholder {\n  padding: 16px;\n  font-size: 13px;\n  color: #90A4AE;\n  line-height: 1.6;\n}\n\n.all-pane-center .ant-tabs {\n  flex: 1 1 auto;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n}\n\n.all-pane-center .ant-tabs-nav {\n  margin: 8px 8px 0;\n}\n\n/* 바깥 탭은 서비스 전환, BankTab 안쪽 탭은 실제 업무 선택이다.\n   두 단계가 같은 버튼처럼 보이지 않도록 바깥 탭은 작고 차분한 탐색 막대로 유지한다. */\n.all-pane-center > .ant-tabs > .ant-tabs-nav {\n  margin: 10px 10px 0;\n  padding: 5px 6px 0;\n  border-radius: 12px 12px 0 0;\n  background: #EEF3F6;\n}\n\n.all-pane-center > .ant-tabs > .ant-tabs-nav::before {\n  border-bottom: 0;\n}\n\n.all-pane-center > .ant-tabs > .ant-tabs-nav .ant-tabs-nav-wrap,\n.all-pane-center > .ant-tabs > .ant-tabs-nav .ant-tabs-nav-list {\n  width: 100%;\n}\n\n.all-pane-center > .ant-tabs > .ant-tabs-nav .ant-tabs-nav-list {\n  gap: 8px;\n}\n\n/* ─── 5개 탭 파스텔 톤 + 액티브 강조 (summary/passport/sticker/bank/alimtalk) ─── */\n.all-pane-center .ant-tabs-card > .ant-tabs-nav .ant-tabs-tab {\n  border: 1px solid transparent !important;\n  border-bottom: none !important;\n  border-radius: 10px 10px 0 0 !important;\n  flex: 1 1 0;\n  justify-content: center;\n  margin: 0 !important;\n  padding: 8px clamp(12px, 1.4vw, 18px) !important;\n  min-height: clamp(52px, 7vh, 62px);\n  font-weight: 700;\n  transition: none !important;\n  position: relative;\n  top: 0;\n}\n.all-pane-center .ant-tabs-card > .ant-tabs-nav .ant-tabs-tab .ant-tabs-tab-btn {\n  font-size: clamp(14px, 1.25vw, 16px);\n}\n\n/* 비활성 탭 — 파스텔 백그라운드 (탭별 색상) — 외부 카드탭만 */\n.all-pane-center > .ant-tabs > .ant-tabs-nav .ant-tabs-tab:nth-of-type(1) { background: #E3F2FD !important; color: #1565C0 !important; }\n.all-pane-center > .ant-tabs > .ant-tabs-nav .ant-tabs-tab:nth-of-type(2) { background: #F3E5F5 !important; color: #6A1B9A !important; }\n.all-pane-center > .ant-tabs > .ant-tabs-nav .ant-tabs-tab:nth-of-type(3) { background: #E8F5E9 !important; color: #2E7D32 !important; }\n.all-pane-center > .ant-tabs > .ant-tabs-nav .ant-tabs-tab:nth-of-type(4) { background: #FFF8E1 !important; color: #E65100 !important; }\n.all-pane-center > .ant-tabs > .ant-tabs-nav .ant-tabs-tab:nth-of-type(5) { background: #FCE4EC !important; color: #AD1457 !important; }\n\n/* 호버 (활성 아닌 탭만) — 파스텔 약간 진해짐 */\n.all-pane-center > .ant-tabs > .ant-tabs-nav .ant-tabs-tab:not(.ant-tabs-tab-active):not(.ant-tabs-tab-disabled):hover:nth-of-type(1) { background: #BBDEFB !important; }\n.all-pane-center > .ant-tabs > .ant-tabs-nav .ant-tabs-tab:not(.ant-tabs-tab-active):not(.ant-tabs-tab-disabled):hover:nth-of-type(2) { background: #E1BEE7 !important; }\n.all-pane-center > .ant-tabs > .ant-tabs-nav .ant-tabs-tab:not(.ant-tabs-tab-active):not(.ant-tabs-tab-disabled):hover:nth-of-type(3) { background: #C8E6C9 !important; }\n.all-pane-center > .ant-tabs > .ant-tabs-nav .ant-tabs-tab:not(.ant-tabs-tab-active):not(.ant-tabs-tab-disabled):hover:nth-of-type(4) { background: #FFECB3 !important; }\n.all-pane-center > .ant-tabs > .ant-tabs-nav .ant-tabs-tab:not(.ant-tabs-tab-active):not(.ant-tabs-tab-disabled):hover:nth-of-type(5) { background: #F8BBD0 !important; }\n\n/* 활성 탭 — 진한 색 + 흰 글자 + 위로 살짝 솟음 + 굵은 하단 강조선 */\n.all-pane-center > .ant-tabs > .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab-active {\n  transform: none;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);\n  font-weight: 800 !important;\n}\n.all-pane-center > .ant-tabs > .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab-active::after {\n  content: none;\n}\n.all-pane-center > .ant-tabs > .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {\n  color: #fff !important;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);\n}\n\n.all-pane-center > .ant-tabs > .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab-active:nth-of-type(1) { background: #1976D2 !important; color: #fff !important; }\n.all-pane-center > .ant-tabs > .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab-active:nth-of-type(2) { background: #7B1FA2 !important; color: #fff !important; }\n.all-pane-center > .ant-tabs > .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab-active:nth-of-type(3) { background: #2E7D32 !important; color: #fff !important; }\n.all-pane-center > .ant-tabs > .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab-active:nth-of-type(4) { background: #F57C00 !important; color: #fff !important; }\n.all-pane-center > .ant-tabs > .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab-active:nth-of-type(5) { background: #C2185B !important; color: #fff !important; }\n\n/* 비활성(disabled — 회원 미식별) 상태는 더 흐리게 */\n.all-pane-center > .ant-tabs > .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab-disabled {\n  opacity: 0.55;\n  filter: saturate(0.5);\n}\n\n/* 콘텐츠 영역에 액티브 탭 색상 톤의 옅은 백그라운드 — 외부 탭만 */\n.all-pane-center > .ant-tabs > .ant-tabs-content-holder {\n  border-top: 3px solid transparent;\n  background: #FAFAFA;\n}\n.all-pane-center > .ant-tabs:has(> .ant-tabs-nav .ant-tabs-tab-active:nth-of-type(1)) > .ant-tabs-content-holder { background: #F5FAFE; border-top-color: #1976D2; }\n.all-pane-center > .ant-tabs:has(> .ant-tabs-nav .ant-tabs-tab-active:nth-of-type(2)) > .ant-tabs-content-holder { background: #FBF6FC; border-top-color: #7B1FA2; }\n.all-pane-center > .ant-tabs:has(> .ant-tabs-nav .ant-tabs-tab-active:nth-of-type(3)) > .ant-tabs-content-holder { background: #F6FBF6; border-top-color: #2E7D32; }\n.all-pane-center > .ant-tabs:has(> .ant-tabs-nav .ant-tabs-tab-active:nth-of-type(4)) > .ant-tabs-content-holder { background: #FFFBEF; border-top-color: #F57C00; }\n.all-pane-center > .ant-tabs:has(> .ant-tabs-nav .ant-tabs-tab-active:nth-of-type(5)) > .ant-tabs-content-holder { background: #FDF3F7; border-top-color: #C2185B; }\n\n.all-pane-center .ant-tabs-content-holder {\n  flex: 1 1 auto;\n  overflow: auto;\n  padding: 0 clamp(10px, 1.4vw, 20px) clamp(10px, 1.4vw, 20px);\n}\n\n.tab-placeholder {\n  padding: 24px;\n  color: #607D8B;\n}\n\n.tab-placeholder h3 {\n  margin: 0 0 8px;\n  color: #263238;\n}\n\n.tab-pane {\n  padding: clamp(10px, 1.4vw, 20px);\n}\n\n/* 회원 검색 전 빈 상태: 넓은 작업영역 안에서 안내가 묻히지 않게 한다. */\n.all-pane-center .ant-empty-normal {\n  width: min(460px, 78%);\n  margin: clamp(52px, 14vh, 130px) auto 0;\n  padding: clamp(28px, 4vw, 52px);\n  border: 2px dashed #CBD8E0;\n  border-radius: 22px;\n  background: rgba(255, 255, 255, 0.82);\n}\n\n.all-pane-center .ant-empty-normal .ant-empty-image {\n  height: clamp(84px, 11vw, 124px);\n  margin-bottom: 14px;\n}\n\n.all-pane-center .ant-empty-normal .ant-empty-description {\n  color: #455A64;\n  font-size: clamp(18px, 1.65vw, 22px);\n  font-weight: 700;\n}\n\n.session-log-list {\n  list-style: none;\n  margin: 0;\n  padding: 8px 12px;\n  overflow-y: auto;\n}\n\n.session-log-item {\n  display: flex;\n  gap: 8px;\n  padding: 6px 4px;\n  border-bottom: 1px solid #ECEFF1;\n  font-size: 12px;\n}\n\n.session-log-ts {\n  color: #90A4AE;\n  font-family: ui-monospace, \"Menlo\", monospace;\n  flex-shrink: 0;\n}\n\n.session-log-msg {\n  color: #263238;\n  word-break: keep-all;\n}\n\n/* ── 작업 로그 접이식 토글 (화면 좁음 대응) ───────────────────── */\n/* 접힘: 얇은 세로 띠로 축소 → .all-pane-center(flex:1 1) 가 남는 폭을 자동 흡수 */\n.all-pane-right.is-collapsed {\n  flex: 0 0 34px;\n  min-width: 34px;\n  cursor: pointer;\n}\n\n/* 확장 상태 헤더: 제목 + 접기 버튼 한 줄 */\n.pane-title-log {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n/* 공통 토글 버튼 */\n.session-log-toggle {\n  border: none;\n  background: transparent;\n  color: #607D8B;\n  cursor: pointer;\n  padding: 0;\n  font-size: 13px;\n  line-height: 1;\n}\n.session-log-toggle.is-expanded {\n  padding: 2px 6px;\n  border-radius: 4px;\n}\n.session-log-toggle.is-expanded:hover {\n  background: #ECEFF1;\n  color: #37474F;\n}\n\n/* 접힘 상태: 세로 세워진 라벨 + 화살표(패널 전체가 버튼) */\n.session-log-toggle.is-collapsed {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 0;\n  color: #607D8B;\n}\n.session-log-toggle.is-collapsed:hover {\n  background: #F5F7F8;\n  color: #37474F;\n}\n.session-log-toggle-arrow {\n  font-size: 14px;\n}\n.session-log-toggle-label {\n  writing-mode: vertical-rl;\n  text-orientation: mixed;\n  font-size: 13px;\n  font-weight: 600;\n  letter-spacing: 1px;\n}\n.session-log-toggle-badge {\n  margin-top: auto;\n  min-width: 18px;\n  padding: 1px 5px;\n  border-radius: 9px;\n  background: #455A64;\n  color: #fff;\n  font-size: 11px;\n  font-weight: 700;\n  text-align: center;\n}\n\n.sticker-family-list {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.sticker-family-card {\n  cursor: pointer;\n  border: 1px solid #CFD8DC;\n}\n\n.sticker-family-card.selected {\n  border-color: #455A64;\n  background: #ECEFF1;\n}\n\n/* 티켓→전화번호 진행 안내 시 패드 강조 */\n.phone-section-flash {\n  outline: 3px solid rgba(255, 152, 0, 0.45);\n  outline-offset: -3px;\n  border-radius: 6px;\n}\n\n/* 전화번호 오입력 방지: 올인원 패드의 각 키를 가로 폭과 같은 정사각형 터치 영역으로 유지 */\n.all-in-one-page .phone-numpad .numpad-key {\n  width: 100%;\n  height: auto;\n  min-height: 0;\n  aspect-ratio: 1 / 1;\n}\n\n/* 낮은 가로 화면에서는 정사각형 키가 세로 공간을 넘지 않도록 남은 높이에 맞춰 축소한다. */\n@media (orientation: landscape) and (max-height: 900px) {\n  .all-in-one-page .all-pane-left > .identify-section {\n    flex: 1 1 auto;\n    min-height: 0;\n  }\n\n  .all-in-one-page .all-pane-left .phone-numpad {\n    box-sizing: border-box;\n    height: 100%;\n    min-height: 0;\n    gap: 6px;\n    padding: 8px 12px;\n  }\n\n  .all-in-one-page .all-pane-left .phone-display {\n    flex: 0 0 auto;\n    padding: 6px 10px;\n  }\n\n  .all-in-one-page .all-pane-left .phone-help,\n  .all-in-one-page .all-pane-left .phone-error {\n    flex: 0 0 auto;\n    line-height: 1.2;\n  }\n\n  .all-in-one-page .all-pane-left .numpad-grid {\n    flex: 1 1 auto;\n    min-height: 0;\n    grid-template-rows: repeat(4, minmax(0, 1fr));\n  }\n\n  .all-in-one-page .phone-numpad .numpad-key {\n    height: 100%;\n    aspect-ratio: auto;\n  }\n\n  .all-in-one-page .all-pane-left .phone-submit {\n    flex: 0 0 clamp(40px, 6.5vh, 48px);\n    height: clamp(40px, 6.5vh, 48px);\n    min-height: 0;\n  }\n}\n\n.session-log-list-full { max-height: none; padding: 0; margin: 0; list-style: none; }\n\n/* ─── BankTab ─── */\n.bank-tab-allinone {\n  display: flex;\n  flex-direction: column;\n  gap: clamp(8px, 1.1vw, 14px);\n  height: 100%;\n}\n\n.bank-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n/* 가족 선택 정보는 이름·관계·잔액을 말줄임표 없이 모두 표시한다. */\n.bank-header .ant-segmented {\n  width: 100%;\n  padding: 4px;\n  border: 1px solid #CFD8E1;\n  background: #EAF0F4;\n  border-radius: 14px;\n  box-shadow: inset 0 1px 2px rgba(38, 50, 56, 0.05);\n}\n\n.bank-header .ant-segmented-item-label {\n  height: auto;\n  min-height: clamp(42px, 5.4vh, 52px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  white-space: normal;\n  overflow: visible;\n  text-overflow: clip;\n  overflow-wrap: anywhere;\n  padding: 5px 10px;\n  font-size: clamp(14px, 1.3vw, 17px);\n  line-height: 1.25;\n}\n\n.bank-header .ant-segmented-item-selected .ant-segmented-item-label {\n  font-weight: 800;\n  color: #0F5CAD;\n}\n\n.bank-header .ant-segmented-item-selected {\n  box-shadow: 0 2px 7px rgba(21, 101, 192, 0.14);\n}\n\n/* 가족을 누를 때 선택 배경이 미끄러지지 않고 즉시 바뀌게 한다. */\n.bank-header .ant-segmented-thumb,\n.bank-header .ant-segmented-item,\n.bank-header .ant-segmented-item::after {\n  animation: none !important;\n  transition: none !important;\n}\n\n.bank-pane {\n  display: flex;\n  flex-direction: column;\n  gap: clamp(9px, 1vw, 14px);\n  padding: clamp(8px, 1vw, 14px) 4px 0;\n}\n\n/* 내부 BankTab(인출/저축/기부) — 기능별 파스텔 + 적당한 간격 + 큰 폰트 */\n.bank-tab-allinone .ant-tabs-nav .ant-tabs-tab {\n  padding: 6px 12px !important;\n  width: auto;\n  min-height: clamp(54px, 7vh, 64px);\n  justify-content: center;\n  border-radius: 8px 8px 0 0 !important;\n  border: 1px solid transparent !important;\n  font-size: clamp(17px, 1.5vw, 20px) !important;\n  font-weight: 600 !important;\n  line-height: 1.2 !important;\n  transition: none !important;\n}\n.bank-tab-allinone .ant-tabs-nav {\n  margin-bottom: 6px !important;\n  padding-bottom: 0;\n  border-bottom: 1px solid #DCE3E8;\n}\n\n.bank-tab-allinone > .ant-tabs > .ant-tabs-nav .ant-tabs-nav-wrap {\n  flex: 1 1 auto;\n}\n\n.bank-tab-allinone > .ant-tabs > .ant-tabs-nav .ant-tabs-nav-list {\n  width: 100%;\n}\n\n.bank-tab-allinone > .ant-tabs > .ant-tabs-nav .ant-tabs-tab {\n  flex: 1 1 0;\n}\n.bank-tab-allinone .ant-tabs-nav .ant-tabs-tab + .ant-tabs-tab {\n  margin-left: 3px !important;\n}\n\n/* 비활성 — 파스텔 */\n.bank-tab-allinone .ant-tabs-nav .ant-tabs-tab:nth-of-type(1) { background: #FFF3E0 !important; color: #E65100 !important; }\n.bank-tab-allinone .ant-tabs-nav .ant-tabs-tab:nth-of-type(2) { background: #E3F2FD !important; color: #1565C0 !important; }\n.bank-tab-allinone .ant-tabs-nav .ant-tabs-tab:nth-of-type(3) { background: #FCE4EC !important; color: #AD1457 !important; }\n\n/* 호버 (활성 아닌 탭) */\n.bank-tab-allinone .ant-tabs-nav .ant-tabs-tab:not(.ant-tabs-tab-active):hover:nth-of-type(1) { background: #FFE0B2 !important; }\n.bank-tab-allinone .ant-tabs-nav .ant-tabs-tab:not(.ant-tabs-tab-active):hover:nth-of-type(2) { background: #BBDEFB !important; }\n.bank-tab-allinone .ant-tabs-nav .ant-tabs-tab:not(.ant-tabs-tab-active):hover:nth-of-type(3) { background: #F8BBD0 !important; }\n\n/* 활성 — 진한 색 + 흰 글자 */\n.bank-tab-allinone .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab-active {\n  transform: none;\n  box-shadow: inset 0 -5px 0 rgba(0, 0, 0, 0.14);\n  font-weight: 800 !important;\n}\n.bank-tab-allinone .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {\n  color: #fff !important;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);\n}\n.bank-tab-allinone .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab-active:nth-of-type(1) { background: #F57C00 !important; }\n.bank-tab-allinone .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab-active:nth-of-type(2) { background: #1976D2 !important; }\n.bank-tab-allinone .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab-active:nth-of-type(3) { background: #C2185B !important; }\n\n/* 터치에서 툴팁에 의존하지 않도록 이력/새로고침을 서로 다른 보조색으로 구분한다. */\n.bank-tab-allinone .ant-tabs-extra-content .ant-space-item .ant-btn {\n  min-width: 58px !important;\n  height: 56px !important;\n  min-height: 56px !important;\n  border-radius: 12px;\n  font-size: 19px;\n  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08);\n}\n\n.bank-tab-allinone .ant-tabs-extra-content .ant-space-item:first-child .ant-btn {\n  color: #6A1B9A;\n  border-color: #CE93D8;\n  background: #FAF5FF;\n}\n\n.bank-tab-allinone .ant-tabs-extra-content .ant-space-item:last-child .ant-btn {\n  color: #1565C0;\n  border-color: #90CAF9;\n  background: #F3F8FE;\n}\n\n.bank-action-row {\n  display: grid;\n  grid-template-columns: clamp(190px, 23vw, 250px) minmax(240px, 1fr);\n  gap: clamp(10px, 1vw, 14px);\n  align-items: stretch;\n  min-height: 64px;\n}\n\n.bank-balance-card {\n  background: linear-gradient(135deg, #FFF7D6, #FFE8A3);\n  border: 2px solid #F9C642;\n  border-radius: 14px;\n  padding: 10px 18px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 2px;\n  min-height: 64px;\n}\n\n.bank-full-exchange-btn {\n  height: 100% !important;\n  min-height: 64px;\n  font-size: clamp(18px, 1.6vw, 21px) !important;\n  font-weight: 800 !important;\n  border-radius: 12px !important;\n}\n\n.bank-balance-value {\n  font-size: clamp(27px, 2.4vw, 34px);\n  font-weight: 800;\n  color: #FB8C00;\n  line-height: 1.1;\n}\n\n.bank-balance-unit {\n  font-size: clamp(14px, 1.25vw, 17px);\n  margin-left: 2px;\n  color: #FB8C00;\n  font-weight: 600;\n}\n\n.bank-input-card {\n  background: #fff;\n  border: 1px solid #E0E0E0;\n  border-radius: 14px;\n  padding: clamp(12px, 1.2vw, 18px);\n  display: flex;\n  flex-direction: column;\n  gap: clamp(9px, 1vw, 13px);\n  box-shadow: 0 4px 14px rgba(38, 50, 56, 0.08);\n}\n\n@media (max-width: 900px) {\n  .bank-action-row { grid-template-columns: 1fr; }\n}\n\n/* 숫자패드 트리거(클릭 가능 큰 디스플레이) */\n.bank-amount-display {\n  appearance: none;\n  background: linear-gradient(135deg, #FFF9E7, #FFE4AD);\n  border: 3px dashed #F5A000;\n  border-radius: 14px;\n  padding: 12px 14px 10px;\n  color: #E65100;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 2px;\n  transition: none;\n  width: 100%;\n  min-height: clamp(72px, 9vh, 92px);\n  line-height: 1;\n}\n.bank-amount-value {\n  font-size: clamp(34px, 3.2vw, 44px);\n  font-weight: 800;\n  color: #E65100;\n  display: inline-flex;\n  align-items: baseline;\n  gap: 2px;\n  line-height: 1;\n}\n.bank-amount-display:hover:not(:disabled) {\n  background: #FFF1CB;\n  box-shadow: 0 5px 16px rgba(255, 152, 0, 0.28);\n}\n.bank-amount-display:active:not(:disabled) {\n  transform: none;\n  background: #FFE3A0;\n}\n.bank-amount-display:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n.bank-amount-unit {\n  font-size: clamp(18px, 1.6vw, 22px);\n  margin-left: 4px;\n  font-weight: 700;\n  color: #E65100;\n}\n.bank-amount-hint {\n  font-size: clamp(12px, 1.1vw, 14px);\n  font-weight: 600;\n  color: #8D6E63;\n  letter-spacing: 0.3px;\n}\n\n.bank-pane > .ant-btn {\n  min-height: clamp(58px, 7.2vh, 68px) !important;\n  font-size: clamp(17px, 1.5vw, 20px) !important;\n  font-weight: 800 !important;\n  border-radius: 12px !important;\n}\n\n/* 실제 후보 중 가장 낮은 600px 높이에서는 정보 크기는 유지하고 여백만 줄인다. */\n@media (orientation: landscape) and (max-height: 700px) {\n  .all-main { gap: 8px; padding: 8px; }\n  .all-pane-left { flex-basis: clamp(250px, 26vw, 270px); }\n  .all-pane-center .ant-tabs-content-holder { padding: 0 9px 9px; }\n  .tab-pane { padding: 9px; }\n  .bank-header .ant-segmented-item-label { min-height: 40px; padding-block: 3px; }\n  .bank-tab-allinone .ant-tabs-nav .ant-tabs-tab { min-height: 54px; }\n  .bank-tab-allinone .ant-tabs-extra-content .ant-space-item .ant-btn {\n    height: 54px !important;\n    min-height: 54px !important;\n  }\n  .bank-action-row,\n  .bank-balance-card,\n  .bank-full-exchange-btn { min-height: 60px; }\n  .bank-input-card { padding: 11px 13px; }\n  .bank-amount-display { min-height: 70px; padding-block: 9px 7px; }\n  .bank-pane > .ant-btn { min-height: 58px !important; }\n}\n\n/* 숫자패드 모달 */\n.bank-numpad {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n.bank-numpad-display {\n  background: #263238;\n  color: #FFD54F;\n  border-radius: 8px;\n  padding: 14px;\n  text-align: right;\n  font-size: 28px;\n  font-weight: 800;\n  font-variant-numeric: tabular-nums;\n  min-height: 56px;\n}\n.bank-numpad-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 8px;\n}\n.bank-numpad-key {\n  appearance: none;\n  height: 56px;\n  border-radius: 10px;\n  border: 1px solid #CFD8DC;\n  background: #ECEFF1;\n  font-size: 22px;\n  font-weight: 700;\n  color: #263238;\n  cursor: pointer;\n  user-select: none;\n}\n.bank-numpad-key:active {\n  background: #B0BEC5;\n}\n.bank-numpad-key.key-clear {\n  background: #FFCDD2;\n  color: #C62828;\n  border-color: #EF9A9A;\n}\n.bank-numpad-key.key-back {\n  background: #E1BEE7;\n  color: #6A1B9A;\n  border-color: #CE93D8;\n}\n.bank-numpad-actions {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 8px;\n}\n\n/* ─── 회원요약 — 헤로 카드 ─── */\n.summary-tab { padding: 4px 4px 0; }\n\n.summary-hero {\n  background: linear-gradient(135deg, #E3F2FD, #F5FAFE);\n  border: 1px solid #90CAF9;\n  border-radius: 12px;\n  padding: 12px 14px;\n  margin-bottom: 12px;\n}\n.summary-hero-head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 8px;\n  margin-bottom: 10px;\n}\n.summary-hero-name-wrap { min-width: 0; flex: 1 1 auto; }\n.summary-hero-name {\n  font-size: 22px;\n  font-weight: 800;\n  color: #0D47A1;\n  line-height: 1.2;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.summary-hero-tags { margin-top: 4px; display: flex; gap: 4px; flex-wrap: wrap; }\n.summary-hero-tags .ant-tag { margin: 0; }\n.summary-hero-phone {\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  font-size: 14px;\n  color: #455A64;\n  white-space: nowrap;\n}\n.summary-phone-text { font-weight: 600; }\n\n.summary-stat-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr 1.4fr;\n  gap: 8px;\n}\n.summary-stat-cell {\n  background: rgba(255, 255, 255, 0.8);\n  border-radius: 8px;\n  padding: 8px 10px;\n  min-width: 0;\n}\n.summary-stat-label {\n  font-size: 11px;\n  color: #607D8B;\n  font-weight: 500;\n  margin-bottom: 2px;\n}\n.summary-stat-value {\n  font-size: 18px;\n  font-weight: 700;\n  color: #263238;\n  line-height: 1.1;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.summary-stat-coin { color: #F57C00; }\n.summary-stat-date { font-size: 16px; letter-spacing: -0.3px; }\n.summary-stat-sub {\n  font-size: 11px;\n  color: #90A4AE;\n  margin-top: 2px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* ─── 가족 카드 리스트 ─── */\n.summary-family-section { display: flex; flex-direction: column; gap: 8px; }\n.summary-family-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 2px;\n}\n.summary-family-list {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n.summary-family-card {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 10px;\n  background: #FAFAFA;\n  border: 1px solid #E0E0E0;\n  border-radius: 10px;\n  min-width: 0;\n}\n.summary-family-card.is-me {\n  background: #FFF8E1;\n  border-color: #FFD54F;\n}\n.summary-family-role { margin: 0 !important; flex: 0 0 auto; }\n.summary-family-name {\n  flex: 1 1 auto;\n  min-width: 0;\n  font-size: 15px;\n  font-weight: 600;\n  color: #263238;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.summary-family-coin {\n  margin: 0 !important;\n  flex: 0 0 auto;\n  font-size: 13px;\n  font-weight: 700;\n}\n.summary-family-passport { margin: 0 !important; flex: 0 0 auto; }\n.summary-family-actions { flex: 0 0 auto; margin-left: 4px; }\n.summary-family-actions .ant-btn { min-width: 36px; height: 26px; min-height: 0 !important; padding: 0 8px !important; line-height: 24px !important; }\n.sticker-refresh-btn { height: 26px !important; min-height: 0 !important; padding: 0 10px !important; line-height: 24px !important; font-size: 13px !important; }\n\n/* 좌측 식별 결과 콜아웃 (미등록·티켓없음 등) — 세로 스택, 큰 액션 버튼 */\n.identify-callout {\n  margin: 8px 12px;\n  padding: 12px;\n  border-radius: 10px;\n  border: 1px solid;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.identify-callout-info {\n  background: #E3F2FD;\n  border-color: #90CAF9;\n}\n.identify-callout-error {\n  background: #FFEBEE;\n  border-color: #EF9A9A;\n}\n.identify-callout-head {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-weight: 700;\n  font-size: 14px;\n  color: #1565C0;\n}\n.identify-callout-error .identify-callout-head { color: #C62828; }\n.identify-callout-icon { font-size: 16px; line-height: 1; }\n.identify-callout-title { line-height: 1.3; }\n.identify-callout-desc {\n  font-size: 13px;\n  line-height: 1.5;\n  color: #37474F;\n  word-break: keep-all;\n}\n.identify-callout-action {\n  height: 48px !important;\n  font-size: 15px !important;\n  font-weight: 700 !important;\n  border-radius: 10px !important;\n  margin-top: 4px;\n}\n\n/* ── 미등록 번호 안내 모달 ─────────────────────────────────────\n   인라인 안내가 숫자패드를 화면 밖으로 밀어내서 팝업으로 뺐다(현장 지적 2026-08-21).\n   태블릿에서 장갑 낀 손으로도 눌리도록 버튼을 크게 잡는다. */\n.no-member-body {\n  text-align: center;\n  padding: 8px 4px 4px;\n}\n.no-member-title {\n  font-size: 24px;\n  font-weight: 800;\n  color: #263238;\n  margin-bottom: 6px;\n}\n.no-member-phone {\n  font-size: 30px;\n  font-weight: 800;\n  letter-spacing: 1px;\n  color: #1565C0;\n  font-variant-numeric: tabular-nums;\n  margin-bottom: 12px;\n}\n.no-member-desc {\n  font-size: 15px;\n  line-height: 1.6;\n  color: #37474F;\n  word-break: keep-all;\n  margin-bottom: 20px;\n}\n.no-member-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n.no-member-btn {\n  height: 68px !important;\n  font-size: 20px !important;\n  font-weight: 800 !important;\n  border-radius: 12px !important;\n  white-space: nowrap;\n}\n.no-member-btn-cancel {\n  height: 56px !important;\n  font-size: 17px !important;\n  font-weight: 700 !important;\n}\n\n/* Tablet bank workspace redesign\n   Keep the existing controls and events, but separate search, service choice,\n   and the active task into three stable touch zones. */\n.all-main {\n  gap: clamp(8px, 1vw, 14px);\n  padding: clamp(8px, 1vw, 14px);\n  background: #e8eef3;\n}\n\n.all-pane-left {\n  flex-basis: clamp(252px, 25vw, 320px);\n  border: 0;\n  border-radius: 18px;\n  box-shadow: 0 4px 18px rgba(31, 50, 68, 0.12);\n}\n\n.all-pane-left .pane-title {\n  padding: 14px 16px;\n  color: #f8fafc;\n  background: #24384b;\n  border: 0;\n}\n\n.all-pane-center {\n  border: 0;\n  border-radius: 18px;\n  background: transparent;\n  box-shadow: 0 4px 18px rgba(31, 50, 68, 0.12);\n}\n\n/* Outer tabs become a persistent vertical service rail. */\n.all-pane-center > .ant-tabs {\n  display: grid;\n  grid-template-columns: clamp(108px, 11vw, 142px) minmax(0, 1fr);\n  grid-template-rows: minmax(0, 1fr);\n  min-width: 0;\n  background: #f8fafc;\n}\n\n.all-pane-center > .ant-tabs > .ant-tabs-nav {\n  grid-column: 1;\n  grid-row: 1;\n  min-width: 0;\n  height: 100%;\n  margin: 0;\n  padding: 14px 10px;\n  border-radius: 0;\n  background: #24384b;\n}\n\n.all-pane-center > .ant-tabs > .ant-tabs-nav .ant-tabs-nav-wrap {\n  align-items: flex-start;\n  overflow: visible;\n}\n\n.all-pane-center > .ant-tabs > .ant-tabs-nav .ant-tabs-nav-list {\n  width: 100%;\n  flex-direction: column;\n  gap: 12px;\n  transform: none !important;\n}\n\n.all-pane-center > .ant-tabs.ant-tabs-card > .ant-tabs-nav .ant-tabs-tab {\n  flex: 0 0 auto;\n  width: 100%;\n  min-height: clamp(76px, 10vh, 96px);\n  padding: 10px 7px !important;\n  border: 2px solid transparent !important;\n  border-radius: 14px !important;\n  box-shadow: none;\n}\n\n.all-pane-center > .ant-tabs.ant-tabs-card > .ant-tabs-nav .ant-tabs-tab .ant-tabs-tab-btn {\n  width: 100%;\n  white-space: normal;\n  text-align: center;\n  font-size: clamp(15px, 1.35vw, 18px);\n  line-height: 1.35;\n}\n\n.all-pane-center > .ant-tabs > .ant-tabs-nav .ant-tabs-tab:nth-of-type(1) {\n  color: #c7ddf4 !important;\n  background: #314b63 !important;\n}\n\n.all-pane-center > .ant-tabs > .ant-tabs-nav .ant-tabs-tab:nth-of-type(2) {\n  color: #e9d7f2 !important;\n  background: #3b4560 !important;\n}\n\n.all-pane-center > .ant-tabs > .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab-active:nth-of-type(1) {\n  color: #fff !important;\n  background: #0878d1 !important;\n  border-color: #8dccff !important;\n  box-shadow: 0 5px 14px rgba(0, 83, 151, 0.36);\n}\n\n.all-pane-center > .ant-tabs > .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab-active:nth-of-type(2) {\n  color: #fff !important;\n  background: #7738a2 !important;\n  border-color: #d7aaf2 !important;\n  box-shadow: 0 5px 14px rgba(67, 22, 98, 0.36);\n}\n\n.all-pane-center > .ant-tabs > .ant-tabs-content-holder,\n.all-pane-center > .ant-tabs:has(> .ant-tabs-nav .ant-tabs-tab-active:nth-of-type(1)) > .ant-tabs-content-holder,\n.all-pane-center > .ant-tabs:has(> .ant-tabs-nav .ant-tabs-tab-active:nth-of-type(2)) > .ant-tabs-content-holder {\n  grid-column: 2;\n  grid-row: 1;\n  min-width: 0;\n  min-height: 0;\n  padding: 12px;\n  border-top: 0;\n  border-left: 0;\n  background: #edf3f7;\n}\n\n.all-pane-center > .ant-tabs > .ant-tabs-content-holder > .ant-tabs-content {\n  height: 100%;\n}\n\n.all-pane-center > .ant-tabs > .ant-tabs-content-holder .ant-tabs-tabpane {\n  height: 100%;\n}\n\n.all-pane-center .tab-pane {\n  height: 100%;\n  padding: 0;\n}\n\n/* The bank itself reads as one workspace, with identity above and actions below. */\n.bank-tab-allinone {\n  gap: 12px;\n}\n\n.bank-header .ant-segmented {\n  padding: 5px;\n  border: 0;\n  border-radius: 15px;\n  background: #dfe8ef;\n}\n\n.bank-header .ant-segmented-item {\n  border-radius: 11px;\n}\n\n.bank-header .ant-segmented-item-selected {\n  color: #083f73;\n  background: #fff;\n  box-shadow: 0 2px 8px rgba(31, 50, 68, 0.16);\n}\n\n.bank-tab-allinone > .ant-tabs {\n  flex: 1 1 auto;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.bank-tab-allinone > .ant-tabs > .ant-tabs-nav {\n  flex: 0 0 auto;\n  margin: 0 0 12px !important;\n  padding: 0;\n  border: 0;\n  background: #fff;\n  border-radius: 15px;\n  box-shadow: 0 2px 8px rgba(31, 50, 68, 0.1);\n  overflow: hidden;\n}\n\n.bank-tab-allinone > .ant-tabs > .ant-tabs-nav::before {\n  border: 0;\n}\n\n.bank-tab-allinone > .ant-tabs > .ant-tabs-nav .ant-tabs-tab {\n  min-height: clamp(62px, 8vh, 78px);\n  margin: 0 !important;\n  border-radius: 0 !important;\n}\n\n.bank-tab-allinone > .ant-tabs > .ant-tabs-content-holder {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow: auto;\n}\n\n.bank-tab-allinone > .ant-tabs > .ant-tabs-content-holder > .ant-tabs-content,\n.bank-tab-allinone > .ant-tabs > .ant-tabs-content-holder .ant-tabs-tabpane {\n  height: 100%;\n}\n\n/* Each operation uses two large task cards instead of a vertical form stack. */\n.bank-pane {\n  height: 100%;\n  display: grid;\n  grid-template-columns: minmax(180px, 0.78fr) minmax(275px, 1.22fr);\n  grid-template-rows: minmax(0, 1fr);\n  gap: clamp(12px, 1.4vw, 20px);\n  padding: 0;\n}\n\n.bank-action-row {\n  min-width: 0;\n  min-height: 0;\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-template-rows: minmax(92px, 0.72fr) minmax(74px, 1fr);\n  gap: 12px;\n}\n\n.bank-pane > .bank-balance-card,\n.bank-pane > .ant-alert {\n  min-width: 0;\n  min-height: 0;\n  height: 100%;\n}\n\n.bank-balance-card {\n  min-height: 92px;\n  padding: clamp(14px, 1.6vw, 22px);\n  border: 0;\n  border-radius: 18px;\n  background: #fff0bd;\n  box-shadow: inset 0 0 0 2px #f4bd32;\n}\n\n.bank-full-exchange-btn {\n  min-height: 74px;\n  border-radius: 18px !important;\n}\n\n.bank-input-card {\n  min-width: 0;\n  min-height: 0;\n  height: 100%;\n  justify-content: space-between;\n  padding: clamp(16px, 1.7vw, 24px);\n  border: 0;\n  border-radius: 18px;\n  box-shadow: 0 3px 14px rgba(31, 50, 68, 0.12);\n}\n\n.bank-amount-display {\n  flex: 1 1 auto;\n  min-height: 94px;\n  max-height: 180px;\n  border-radius: 16px;\n}\n\n.bank-pane > .ant-alert {\n  display: flex;\n  align-items: center;\n  padding: clamp(18px, 2vw, 28px);\n  border: 0;\n  border-radius: 18px;\n  font-size: clamp(14px, 1.3vw, 17px);\n}\n\n.bank-pane > .ant-btn {\n  min-height: 64px !important;\n}\n\n@media (orientation: landscape) and (max-height: 700px) {\n  .all-pane-center > .ant-tabs {\n    grid-template-columns: 106px minmax(0, 1fr);\n  }\n\n  .all-pane-center > .ant-tabs > .ant-tabs-nav {\n    padding: 10px 8px;\n  }\n\n  .all-pane-center > .ant-tabs.ant-tabs-card > .ant-tabs-nav .ant-tabs-tab {\n    min-height: 72px;\n  }\n\n  .all-pane-center > .ant-tabs > .ant-tabs-content-holder,\n  .all-pane-center > .ant-tabs:has(> .ant-tabs-nav .ant-tabs-tab-active:nth-of-type(1)) > .ant-tabs-content-holder,\n  .all-pane-center > .ant-tabs:has(> .ant-tabs-nav .ant-tabs-tab-active:nth-of-type(2)) > .ant-tabs-content-holder {\n    padding: 10px;\n  }\n\n  .bank-tab-allinone {\n    gap: 8px;\n  }\n\n  .bank-tab-allinone > .ant-tabs > .ant-tabs-nav {\n    margin-bottom: 8px !important;\n  }\n\n  .bank-tab-allinone > .ant-tabs > .ant-tabs-nav .ant-tabs-tab {\n    min-height: 54px;\n  }\n\n  .bank-pane {\n    gap: 10px;\n  }\n\n  .bank-action-row {\n    grid-template-rows: minmax(76px, 0.7fr) minmax(64px, 1fr);\n    gap: 8px;\n  }\n\n  .bank-balance-card,\n  .bank-full-exchange-btn {\n    min-height: 64px;\n  }\n\n  .bank-input-card {\n    padding: 12px;\n  }\n\n  .bank-amount-display {\n    min-height: 76px;\n  }\n}\n\n@media (max-width: 820px) {\n  .all-pane-center > .ant-tabs {\n    grid-template-columns: 96px minmax(0, 1fr);\n  }\n\n  .bank-pane {\n    grid-template-columns: 1fr;\n    grid-template-rows: auto auto;\n  }\n\n  .bank-action-row {\n    grid-template-columns: minmax(150px, 0.8fr) minmax(210px, 1.2fr);\n    grid-template-rows: minmax(70px, auto);\n  }\n}\n\n/* Tablet bank workspace v2\n   Operator flow: phone search -> family member -> transaction. */\n.all-in-one-page *,\n.all-in-one-page *::before,\n.all-in-one-page *::after {\n  animation: none !important;\n  transition: none !important;\n  scroll-behavior: auto !important;\n}\n\n.all-main {\n  gap: 8px;\n  padding: 8px;\n  background: #dfe6ec;\n}\n\n.all-pane-left {\n  flex-basis: clamp(246px, 26vw, 300px);\n  border-radius: 10px;\n  box-shadow: none;\n}\n\n.all-pane-left .pane-title {\n  padding: 11px 14px;\n  background: #17334a;\n}\n\n.all-pane-center {\n  border-radius: 10px;\n  box-shadow: none;\n}\n\n/* Service choice: a full-width, two-way switch above the work surface. */\n.all-pane-center > .ant-tabs {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  background: #f7f9fb;\n}\n\n.all-pane-center > .ant-tabs > .ant-tabs-nav {\n  flex: 0 0 auto;\n  width: auto;\n  height: auto;\n  margin: 0;\n  padding: 8px;\n  border-radius: 0;\n  background: #17334a;\n}\n\n.all-pane-center > .ant-tabs > .ant-tabs-nav .ant-tabs-nav-wrap {\n  align-items: stretch;\n  overflow: hidden;\n}\n\n.all-pane-center > .ant-tabs > .ant-tabs-nav .ant-tabs-nav-list {\n  width: 100%;\n  flex-direction: row;\n  gap: 8px;\n}\n\n.all-pane-center > .ant-tabs.ant-tabs-card > .ant-tabs-nav .ant-tabs-tab {\n  flex: 1 1 0;\n  width: auto;\n  min-height: 52px;\n  padding: 7px 12px !important;\n  border: 2px solid transparent !important;\n  border-radius: 8px !important;\n}\n\n.all-pane-center > .ant-tabs.ant-tabs-card > .ant-tabs-nav .ant-tabs-tab .ant-tabs-tab-btn {\n  width: auto;\n  white-space: nowrap;\n  font-size: clamp(16px, 1.45vw, 19px);\n}\n\n.all-pane-center > .ant-tabs > .ant-tabs-nav .ant-tabs-tab:nth-of-type(1),\n.all-pane-center > .ant-tabs > .ant-tabs-nav .ant-tabs-tab:nth-of-type(2) {\n  color: #d7e3ec !important;\n  background: #29465e !important;\n}\n\n.all-pane-center > .ant-tabs > .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab-active:nth-of-type(1) {\n  color: #0b4d82 !important;\n  background: #fff !important;\n  border-color: #4da8ee !important;\n  box-shadow: none;\n}\n\n.all-pane-center > .ant-tabs > .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab-active:nth-of-type(2) {\n  color: #66308b !important;\n  background: #fff !important;\n  border-color: #b786d5 !important;\n  box-shadow: none;\n}\n\n.all-pane-center > .ant-tabs > .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {\n  color: inherit !important;\n  text-shadow: none;\n}\n\n.all-pane-center > .ant-tabs > .ant-tabs-content-holder,\n.all-pane-center > .ant-tabs:has(> .ant-tabs-nav .ant-tabs-tab-active:nth-of-type(1)) > .ant-tabs-content-holder,\n.all-pane-center > .ant-tabs:has(> .ant-tabs-nav .ant-tabs-tab-active:nth-of-type(2)) > .ant-tabs-content-holder {\n  flex: 1 1 auto;\n  min-width: 0;\n  min-height: 0;\n  padding: 8px;\n  border: 0;\n  background: #eef2f5;\n}\n\n/* Family members occupy their own stable column instead of a moving strip. */\n.bank-tab-allinone {\n  display: grid;\n  grid-template-columns: clamp(152px, 18vw, 215px) minmax(0, 1fr);\n  grid-template-rows: minmax(0, 1fr);\n  gap: 8px;\n  min-height: 0;\n}\n\n.bank-header {\n  grid-column: 1;\n  min-width: 0;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: stretch;\n  flex-wrap: nowrap;\n  gap: 8px;\n  padding: 12px 9px;\n  border-radius: 8px;\n  background: #fff;\n  box-shadow: inset 0 0 0 1px #cad5de;\n  overflow: auto;\n}\n\n.bank-header::before {\n  content: \"작업 대상\";\n  display: block;\n  padding: 0 5px 3px;\n  color: #52697b;\n  font-size: 13px;\n  font-weight: 800;\n}\n\n.bank-header .ant-segmented {\n  width: 100%;\n  padding: 0;\n  border: 0;\n  border-radius: 0;\n  background: transparent;\n  box-shadow: none;\n}\n\n.bank-header .ant-segmented-group {\n  display: flex;\n  flex-direction: column;\n  gap: 7px;\n}\n\n.bank-header .ant-segmented-item {\n  flex: 0 0 auto;\n  width: 100%;\n  border: 1px solid #d6dfe6;\n  border-radius: 7px;\n  color: #334b5d;\n  background: #f4f7f9;\n}\n\n.bank-header .ant-segmented-item-label {\n  min-height: 50px;\n  justify-content: flex-start;\n  padding: 8px 10px;\n  text-align: left;\n  font-size: clamp(13px, 1.2vw, 16px);\n}\n\n.bank-header .ant-segmented-item-selected {\n  color: #073d68;\n  border-color: #1976d2;\n  background: #dceeff;\n  box-shadow: inset 5px 0 0 #1976d2;\n}\n\n.bank-tab-allinone > .ant-tabs {\n  grid-column: 2;\n  min-width: 0;\n}\n\n/* Transactions are compact controls; the amount entry remains the primary task. */\n.bank-tab-allinone > .ant-tabs > .ant-tabs-nav {\n  margin: 0 0 8px !important;\n  border-radius: 8px;\n  box-shadow: inset 0 0 0 1px #cad5de;\n}\n\n.bank-tab-allinone > .ant-tabs > .ant-tabs-nav .ant-tabs-tab {\n  min-height: 52px;\n  font-size: clamp(16px, 1.45vw, 19px) !important;\n}\n\n.bank-tab-allinone .ant-tabs-extra-content .ant-space-item .ant-btn {\n  min-width: 52px !important;\n  width: 52px;\n  height: 52px !important;\n  min-height: 52px !important;\n  border-radius: 7px;\n  box-shadow: none;\n}\n\n.bank-pane {\n  height: auto;\n  min-height: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 0;\n}\n\n.bank-action-row {\n  flex: 0 0 auto;\n  min-height: 0;\n  display: grid;\n  grid-template-columns: minmax(150px, 0.85fr) minmax(220px, 1.15fr);\n  grid-template-rows: 74px;\n  gap: 8px;\n}\n\n.bank-balance-card,\n.bank-pane > .bank-balance-card {\n  flex: 0 0 74px;\n  width: 100% !important;\n  height: 74px;\n  min-height: 74px;\n  padding: 9px 14px;\n  border: 1px solid #dfb64b;\n  border-radius: 8px;\n  background: #fff3c9;\n  box-shadow: none;\n}\n\n.bank-balance-value {\n  font-size: clamp(24px, 2.2vw, 31px);\n}\n\n.bank-full-exchange-btn {\n  height: 74px !important;\n  min-height: 74px;\n  border-radius: 8px !important;\n  font-size: clamp(16px, 1.4vw, 19px) !important;\n}\n\n.bank-input-card {\n  flex: 1 1 auto;\n  width: 100%;\n  height: auto;\n  min-height: 0;\n  padding: 12px;\n  gap: 8px;\n  border: 1px solid #cad5de;\n  border-radius: 8px;\n  box-shadow: none;\n}\n\n.bank-amount-display {\n  min-height: 86px;\n  max-height: none;\n  padding: 10px;\n  border-width: 2px;\n  border-radius: 8px;\n}\n\n.bank-amount-value {\n  font-size: clamp(32px, 3vw, 42px);\n}\n\n.bank-input-card > .ant-btn,\n.bank-pane > .ant-btn {\n  flex: 0 0 58px;\n  height: 58px !important;\n  min-height: 58px !important;\n  border-radius: 8px !important;\n  font-size: clamp(16px, 1.4vw, 19px) !important;\n}\n\n.bank-pane > .ant-alert {\n  flex: 0 0 auto;\n  width: 100%;\n  height: auto;\n  min-height: 74px;\n  padding: 12px 14px;\n  border: 1px solid #e6c66a;\n  border-radius: 8px;\n}\n\n@media (orientation: landscape) and (max-height: 700px) {\n  .all-pane-center > .ant-tabs {\n    display: flex;\n  }\n\n  .all-pane-center > .ant-tabs > .ant-tabs-nav {\n    width: auto;\n    height: auto;\n    padding: 7px;\n  }\n\n  .all-pane-center > .ant-tabs.ant-tabs-card > .ant-tabs-nav .ant-tabs-tab {\n    min-height: 48px;\n  }\n\n  .all-pane-center > .ant-tabs > .ant-tabs-content-holder,\n  .all-pane-center > .ant-tabs:has(> .ant-tabs-nav .ant-tabs-tab-active:nth-of-type(1)) > .ant-tabs-content-holder,\n  .all-pane-center > .ant-tabs:has(> .ant-tabs-nav .ant-tabs-tab-active:nth-of-type(2)) > .ant-tabs-content-holder {\n    padding: 7px;\n  }\n\n  .bank-tab-allinone {\n    grid-template-columns: clamp(145px, 18vw, 190px) minmax(0, 1fr);\n    gap: 7px;\n  }\n\n  .bank-header {\n    padding: 9px 7px;\n  }\n\n  .bank-header .ant-segmented-item-label {\n    min-height: 44px;\n    padding: 6px 8px;\n  }\n\n  .bank-tab-allinone > .ant-tabs > .ant-tabs-nav .ant-tabs-tab,\n  .bank-tab-allinone .ant-tabs-extra-content .ant-space-item .ant-btn {\n    min-height: 48px !important;\n    height: 48px !important;\n  }\n\n  .bank-tab-allinone .ant-tabs-extra-content .ant-space-item .ant-btn {\n    width: 48px;\n    min-width: 48px !important;\n  }\n\n  .bank-action-row {\n    grid-template-rows: 66px;\n  }\n\n  .bank-balance-card,\n  .bank-pane > .bank-balance-card,\n  .bank-full-exchange-btn {\n    flex-basis: 66px;\n    height: 66px !important;\n    min-height: 66px;\n  }\n\n  .bank-input-card {\n    padding: 10px;\n  }\n\n  .bank-amount-display {\n    min-height: 76px;\n  }\n\n  .bank-input-card > .ant-btn,\n  .bank-pane > .ant-btn {\n    flex-basis: 54px;\n    height: 54px !important;\n    min-height: 54px !important;\n  }\n}\n\n@media (max-width: 760px) {\n  .bank-tab-allinone {\n    grid-template-columns: 1fr;\n    grid-template-rows: auto minmax(0, 1fr);\n  }\n\n  .bank-header {\n    grid-column: 1;\n    max-height: none;\n  }\n\n  .bank-header::before {\n    display: none;\n  }\n\n  .bank-header .ant-segmented-group {\n    flex-direction: row;\n  }\n\n  .bank-tab-allinone > .ant-tabs {\n    grid-column: 1;\n  }\n}\n\n/* v2 detail corrections from 1000x600 device review */\n.all-pane-left .pane-title,\n.all-pane-center > .ant-tabs > .ant-tabs-nav {\n  box-sizing: border-box;\n  min-height: 62px;\n}\n\n.all-pane-left .pane-title {\n  display: flex;\n  align-items: center;\n}\n\n.all-pane-center > .ant-tabs > .ant-tabs-content-holder .ant-empty-normal {\n  width: 100%;\n  height: 100%;\n  min-height: 260px;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  transform: translateY(-18px);\n}\n\n.all-pane-center > .ant-tabs > .ant-tabs-content-holder .ant-empty-description {\n  font-size: 0;\n}\n\n.all-pane-center > .ant-tabs > .ant-tabs-content-holder .ant-empty-description::after {\n  content: \"회원을 검색해 주세요\";\n  color: #607586;\n  font-size: 15px;\n  font-weight: 600;\n}\n\n.all-in-one-page .phone-submit .anticon {\n  display: none;\n}\n\n.all-in-one-page .phone-submit {\n  gap: 0;\n  letter-spacing: 0.02em;\n}\n\n.bank-tab-allinone {\n  position: relative;\n}\n\n.bank-tab-allinone > .ant-tabs {\n  grid-column: 2;\n  grid-row: 1;\n}\n\n.bank-header {\n  position: relative;\n  grid-column: 1;\n  grid-row: 1;\n  overflow: hidden;\n}\n\n.bank-header .ant-segmented {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-x: hidden;\n  overflow-y: auto;\n  scrollbar-gutter: stable;\n}\n\n.bank-header > .ant-typography {\n  width: 100%;\n  min-height: 50px;\n  margin: 0 !important;\n  padding: 11px 10px;\n  border: 1px solid #1976d2;\n  border-radius: 7px;\n  color: #073d68;\n  background: #dceeff;\n  box-shadow: inset 5px 0 0 #1976d2;\n  font-size: clamp(14px, 1.3vw, 17px);\n}\n\n/* Passport ownership is metadata, not another grid column. */\n.bank-tab-allinone:has(> .bank-header + .ant-tag) > .bank-header {\n  padding-top: 70px;\n}\n\n.bank-tab-allinone:has(> .bank-header + .ant-tag) > .bank-header::before {\n  position: absolute;\n  top: 12px;\n  left: 14px;\n}\n\n.bank-tab-allinone > .bank-header + .ant-tag {\n  position: absolute;\n  z-index: 2;\n  top: 40px;\n  left: 9px;\n  width: calc(clamp(152px, 18vw, 215px) - 18px);\n  height: 25px;\n  margin: 0 !important;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  line-height: 23px;\n}\n\n/* One neutral color system for transaction choices. */\n.bank-tab-allinone .ant-tabs-nav .ant-tabs-tab:nth-of-type(1),\n.bank-tab-allinone .ant-tabs-nav .ant-tabs-tab:nth-of-type(2),\n.bank-tab-allinone .ant-tabs-nav .ant-tabs-tab:nth-of-type(3) {\n  color: #40576a !important;\n  background: #e7edf2 !important;\n}\n\n.bank-tab-allinone .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab-active:nth-of-type(1),\n.bank-tab-allinone .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab-active:nth-of-type(2),\n.bank-tab-allinone .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab-active:nth-of-type(3) {\n  color: #fff !important;\n  background: #1769aa !important;\n  box-shadow: inset 0 -4px 0 #0d4673;\n}\n\n.bank-tab-allinone .ant-tabs-extra-content {\n  margin-left: 8px;\n  padding-left: 8px;\n  border-left: 1px solid #bdc9d2;\n}\n\n.bank-tab-allinone .ant-tabs-extra-content .ant-space-item:first-child .ant-btn,\n.bank-tab-allinone .ant-tabs-extra-content .ant-space-item:last-child .ant-btn {\n  color: #344e62;\n  border-color: #b9c6d0;\n  background: #f7f9fa;\n}\n\n/* Full and partial exchange are presented inside one operation card. */\n.bank-pane:has(> .bank-action-row) {\n  padding: 10px;\n  border: 1px solid #c8d3dc;\n  border-radius: 8px;\n  background: #fff;\n}\n\n.bank-pane:has(> .bank-action-row) .bank-input-card {\n  padding: 10px 0 0;\n  border: 0;\n  border-top: 1px solid #d8e0e6;\n  border-radius: 0;\n}\n\n.bank-pane:has(> .bank-action-row) .bank-input-card > .ant-typography:first-child {\n  color: #21394c;\n  font-size: 15px;\n}\n\n.bank-input-card .ant-alert {\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n/* Amount controls should look like inputs, not decorative banners. */\n.bank-amount-display {\n  border: 2px solid #8fa4b4;\n  background: #f8fafb;\n}\n\n.bank-amount-display:hover:not(:disabled),\n.bank-amount-display:active:not(:disabled) {\n  border-color: #1769aa;\n  background: #edf6fd;\n  box-shadow: none;\n}\n\n.bank-amount-value,\n.bank-amount-unit {\n  color: #123f62;\n}\n\n.bank-amount-hint {\n  color: #52697b;\n}\n\n@media (orientation: landscape) and (max-height: 700px) {\n  .all-pane-left .pane-title,\n  .all-pane-center > .ant-tabs > .ant-tabs-nav {\n    min-height: 62px;\n  }\n\n  .bank-tab-allinone:has(> .bank-header + .ant-tag) > .bank-header {\n    padding-top: 64px;\n  }\n\n  .bank-tab-allinone:has(> .bank-header + .ant-tag) > .bank-header::before {\n    top: 9px;\n    left: 12px;\n  }\n\n  .bank-tab-allinone > .bank-header + .ant-tag {\n    top: 37px;\n    left: 7px;\n    width: calc(clamp(145px, 18vw, 190px) - 14px);\n  }\n}\n\n/* Device-review corrections: exact icon removal and true empty-state centering. */\n.all-in-one-page .phone-submit {\n  font-size: 0 !important;\n}\n\n.all-in-one-page .phone-submit::after {\n  content: \"조회\";\n  font-size: 16px;\n  font-weight: 800;\n}\n\n.all-pane-center > .ant-tabs > .ant-tabs-content-holder:has(.ant-empty) {\n  position: relative;\n  overflow: hidden;\n}\n\n.all-pane-center > .ant-tabs > .ant-tabs-content-holder:has(.ant-empty) > .ant-tabs-content,\n.all-pane-center > .ant-tabs > .ant-tabs-content-holder:has(.ant-empty) .ant-tabs-tabpane-active,\n.all-pane-center > .ant-tabs > .ant-tabs-content-holder:has(.ant-empty) .tab-pane {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100% !important;\n  min-height: 100%;\n}\n\n.all-pane-center > .ant-tabs > .ant-tabs-content-holder:has(.ant-empty) .tab-pane {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.all-pane-center > .ant-tabs > .ant-tabs-content-holder:has(.ant-empty) .ant-empty-normal {\n  width: min(420px, 78%);\n  height: auto;\n  min-height: 0;\n  margin: 0;\n  padding: 28px;\n  transform: none;\n}\n\n/* Selected operator target must be unmistakable at a glance. */\n.bank-header .ant-segmented-item-selected {\n  color: #fff !important;\n  border: 2px solid #073e69 !important;\n  background: #1769aa !important;\n  box-shadow: inset 6px 0 0 #082f4b, 0 0 0 2px #acd8f7 !important;\n}\n\n.bank-header .ant-segmented-item-selected .ant-segmented-item-label {\n  color: #fff !important;\n  font-weight: 800;\n}\n\n.bank-header > .ant-typography {\n  color: #fff !important;\n  border: 2px solid #073e69;\n  background: #1769aa;\n  box-shadow: inset 6px 0 0 #082f4b, 0 0 0 2px #acd8f7;\n}\n\n/* Exchange is one operation: balance above, equal full/partial choices below. */\n.bank-pane:has(> .bank-action-row) {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  grid-template-rows: 68px 104px auto;\n  align-content: start;\n  gap: 8px;\n  padding: 10px;\n}\n\n.bank-pane:has(> .bank-action-row) > .bank-action-row,\n.bank-pane:has(> .bank-action-row) > .bank-input-card {\n  display: contents;\n}\n\n.bank-pane:has(> .bank-action-row) .bank-balance-card {\n  grid-column: 1 / -1;\n  grid-row: 1;\n  width: 100% !important;\n  height: 68px;\n  min-height: 68px;\n}\n\n.bank-pane:has(> .bank-action-row) .bank-full-exchange-btn {\n  grid-column: 1;\n  grid-row: 2;\n  align-self: stretch;\n  width: 100%;\n  height: 104px !important;\n  min-height: 104px;\n  border-radius: 8px !important;\n}\n\n.bank-pane:has(> .bank-action-row) .bank-input-card > .ant-typography:first-child {\n  display: none;\n}\n\n.bank-pane:has(> .bank-action-row) .bank-amount-display {\n  grid-column: 2;\n  grid-row: 2;\n  align-self: stretch;\n  width: 100%;\n  height: 104px;\n  min-height: 104px;\n}\n\n.bank-pane:has(> .bank-action-row) .bank-input-card > .ant-btn {\n  grid-column: 2;\n  grid-row: 3;\n  width: 100%;\n}\n\n.bank-pane:has(> .bank-action-row) .bank-input-card > .ant-alert {\n  grid-column: 1 / -1;\n  grid-row: 4;\n}\n\n@media (orientation: landscape) and (max-height: 700px) {\n  .bank-pane:has(> .bank-action-row) {\n    grid-template-rows: 62px 92px auto;\n  }\n\n  .bank-pane:has(> .bank-action-row) .bank-balance-card {\n    height: 62px !important;\n    min-height: 62px;\n  }\n\n  .bank-pane:has(> .bank-action-row) .bank-full-exchange-btn,\n  .bank-pane:has(> .bank-action-row) .bank-amount-display {\n    height: 92px !important;\n    min-height: 92px;\n  }\n}\n\n/* Stable phone typography: 010 and entered digits share one rhythm. */\n.all-in-one-page .all-pane-left .phone-display {\n  grid-template-columns: max-content minmax(0, 1fr);\n  column-gap: 9px;\n}\n\n.all-in-one-page .all-pane-left .phone-prefix,\n.all-in-one-page .all-pane-left .phone-digits > span {\n  width: auto;\n  font-size: 20px;\n  font-weight: 700;\n  line-height: 1;\n  font-variant-numeric: tabular-nums;\n}\n\n.all-in-one-page .all-pane-left .phone-digits {\n  grid-template-columns: repeat(8, 1ch);\n  justify-content: start;\n  width: auto;\n  column-gap: clamp(5px, 0.7vw, 8px);\n}\n\n/* Passport metadata must never move the target heading or member list. */\n.bank-header,\n.bank-tab-allinone:has(> .bank-header + .ant-tag) > .bank-header {\n  padding: 68px 9px 9px;\n}\n\n.bank-header::before,\n.bank-tab-allinone:has(> .bank-header + .ant-tag) > .bank-header::before {\n  position: absolute;\n  top: 12px;\n  left: 14px;\n}\n\n.bank-tab-allinone > .bank-header + .ant-tag {\n  top: 38px;\n}\n\n/* Disable AntD's moving layer; use the checked radio as the durable source of truth. */\n.bank-header .ant-segmented-thumb {\n  display: none !important;\n}\n\n.bank-header .ant-segmented-item:has(input:checked),\n.bank-header .ant-segmented-item-selected {\n  color: #fff !important;\n  border: 2px solid #073e69 !important;\n  background: #1769aa !important;\n  box-shadow: inset 6px 0 0 #082f4b, 0 0 0 2px #acd8f7 !important;\n}\n\n.bank-header .ant-segmented-item:has(input:checked) .ant-segmented-item-label,\n.bank-header .ant-segmented-item-selected .ant-segmented-item-label {\n  color: #fff !important;\n  font-weight: 800;\n}\n\n/* All three transactions use the same visual coordinates.\n   Row 1: status/context, row 2: amount, row 3: execute, row 4: calculation/help. */\n.bank-pane,\n.bank-pane:has(> .bank-action-row) {\n  min-height: 100%;\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  grid-template-rows: 68px 92px 54px auto;\n  align-content: start;\n  gap: 8px;\n  padding: 10px;\n  border: 1px solid #c8d3dc;\n  border-radius: 8px;\n  background: #fff;\n}\n\n.bank-pane > .bank-action-row {\n  grid-column: 1;\n  grid-row: 1;\n  min-width: 0;\n  min-height: 0;\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n  grid-template-rows: 68px;\n  gap: 8px;\n}\n\n.bank-pane > .bank-action-row .bank-balance-card,\n.bank-pane > .bank-action-row .bank-full-exchange-btn {\n  width: 100% !important;\n  height: 68px !important;\n  min-height: 68px;\n}\n\n.bank-pane > .bank-balance-card,\n.bank-pane > .ant-alert {\n  grid-column: 1;\n  grid-row: 1;\n  width: 100% !important;\n  height: 68px;\n  min-height: 68px;\n}\n\n.bank-pane > .bank-input-card,\n.bank-pane:has(> .bank-action-row) > .bank-input-card {\n  display: contents;\n}\n\n.bank-pane .bank-input-card > .ant-typography:first-child {\n  display: none;\n}\n\n.bank-pane .bank-amount-display,\n.bank-pane:has(> .bank-action-row) .bank-amount-display {\n  grid-column: 1;\n  grid-row: 2;\n  width: 100%;\n  height: 92px !important;\n  min-height: 92px;\n}\n\n.bank-pane .bank-input-card > .ant-btn,\n.bank-pane:has(> .bank-action-row) .bank-input-card > .ant-btn {\n  grid-column: 1;\n  grid-row: 3;\n  width: 100%;\n  height: 54px !important;\n  min-height: 54px !important;\n}\n\n.bank-pane .bank-input-card > .ant-alert,\n.bank-pane:has(> .bank-action-row) .bank-input-card > .ant-alert {\n  grid-column: 1;\n  grid-row: 4;\n  width: 100%;\n}\n\n@media (orientation: landscape) and (max-height: 700px) {\n  .bank-header,\n  .bank-tab-allinone:has(> .bank-header + .ant-tag) > .bank-header {\n    padding: 62px 7px 7px;\n  }\n\n  .bank-header::before,\n  .bank-tab-allinone:has(> .bank-header + .ant-tag) > .bank-header::before {\n    top: 9px;\n    left: 12px;\n  }\n\n  .bank-tab-allinone > .bank-header + .ant-tag {\n    top: 34px;\n  }\n\n  .bank-pane,\n  .bank-pane:has(> .bank-action-row) {\n    grid-template-rows: 62px 82px 50px auto;\n  }\n\n  .bank-pane > .bank-action-row {\n    grid-template-rows: 62px;\n  }\n\n  .bank-pane > .bank-action-row .bank-balance-card,\n  .bank-pane > .bank-action-row .bank-full-exchange-btn,\n  .bank-pane > .bank-balance-card,\n  .bank-pane > .ant-alert {\n    height: 62px !important;\n    min-height: 62px;\n  }\n\n  .bank-pane .bank-amount-display,\n  .bank-pane:has(> .bank-action-row) .bank-amount-display {\n    height: 82px !important;\n    min-height: 82px;\n  }\n\n  .bank-pane .bank-input-card > .ant-btn,\n  .bank-pane:has(> .bank-action-row) .bank-input-card > .ant-btn {\n    height: 50px !important;\n    min-height: 50px !important;\n  }\n}\n\n/* Robust two-block transaction layout: context above, action card below. */\n.bank-pane,\n.bank-pane:has(> .bank-action-row) {\n  min-height: 100%;\n  height: 100%;\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  grid-template-rows: minmax(84px, auto) minmax(0, 1fr);\n  align-content: stretch;\n  gap: 8px;\n  padding: 10px;\n  overflow: hidden;\n}\n\n.bank-pane > .bank-action-row {\n  grid-column: 1;\n  grid-row: 1;\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  grid-template-rows: minmax(84px, auto);\n  gap: 8px;\n}\n\n.bank-pane > .bank-action-row .bank-balance-card,\n.bank-pane > .bank-action-row .bank-full-exchange-btn,\n.bank-pane > .bank-balance-card,\n.bank-pane > .ant-alert {\n  width: 100% !important;\n  height: auto !important;\n  min-height: 84px;\n  max-height: none;\n}\n\n.bank-pane > .bank-balance-card,\n.bank-pane > .ant-alert {\n  grid-column: 1;\n  grid-row: 1;\n}\n\n.bank-pane > .bank-input-card,\n.bank-pane:has(> .bank-action-row) > .bank-input-card {\n  grid-column: 1;\n  grid-row: 2;\n  min-width: 0;\n  min-height: 0;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 12px;\n  border: 1px solid #c8d3dc;\n  border-radius: 8px;\n  background: #fff;\n}\n\n.bank-pane .bank-input-card > .ant-typography:first-child,\n.bank-pane:has(> .bank-action-row) .bank-input-card > .ant-typography:first-child {\n  display: block;\n  flex: 0 0 auto;\n  color: #21394c;\n  font-size: 16px;\n  font-weight: 800;\n}\n\n.bank-pane .bank-amount-display,\n.bank-pane:has(> .bank-action-row) .bank-amount-display {\n  flex: 1 1 auto;\n  width: 100%;\n  height: auto !important;\n  min-height: 88px;\n}\n\n.bank-pane .bank-input-card > .ant-btn,\n.bank-pane:has(> .bank-action-row) .bank-input-card > .ant-btn {\n  flex: 0 0 54px;\n  width: 100%;\n  height: 54px !important;\n  min-height: 54px !important;\n}\n\n.bank-pane .bank-input-card > .ant-alert,\n.bank-pane:has(> .bank-action-row) .bank-input-card > .ant-alert {\n  flex: 0 0 auto;\n  width: 100%;\n}\n\n/* History and refresh belong directly to the transaction bar. */\n.bank-tab-allinone .ant-tabs-extra-content {\n  margin-left: 4px;\n  padding-left: 0;\n  border-left: 0;\n}\n\n.bank-tab-allinone .ant-tabs-extra-content .ant-space {\n  gap: 2px !important;\n  padding: 0 !important;\n}\n\n.bank-tab-allinone .ant-tabs-extra-content .ant-space-item:first-child .ant-btn,\n.bank-tab-allinone .ant-tabs-extra-content .ant-space-item:last-child .ant-btn {\n  color: #344e62;\n  border-color: transparent;\n  background: transparent;\n}\n\n.bank-tab-allinone .ant-tabs-extra-content .ant-space-item .ant-btn:active {\n  color: #0d5c96;\n  background: #d9e7f1;\n}\n\n/* Denser, more legible target list; only the list itself scrolls. */\n.bank-header::before {\n  color: #21394c;\n  font-size: 16px;\n  font-weight: 900;\n}\n\n.bank-header .ant-segmented-group {\n  align-content: start;\n}\n\n.bank-header .ant-segmented-item {\n  flex: 0 0 62px;\n  min-height: 62px;\n}\n\n.bank-header .ant-segmented-item-label {\n  min-height: 58px;\n  padding: 9px 10px;\n  font-size: clamp(15px, 1.35vw, 17px);\n  font-weight: 700;\n  line-height: 1.3;\n}\n\n.bank-header > .ant-typography {\n  min-height: 62px;\n  padding: 15px 11px;\n  font-size: clamp(16px, 1.4vw, 18px);\n  font-weight: 800;\n}\n\n@media (orientation: landscape) and (max-height: 700px) {\n  .bank-pane,\n  .bank-pane:has(> .bank-action-row) {\n    grid-template-rows: minmax(76px, auto) minmax(0, 1fr);\n    padding: 8px;\n  }\n\n  .bank-pane > .bank-action-row {\n    grid-template-rows: minmax(76px, auto);\n  }\n\n  .bank-pane > .bank-action-row .bank-balance-card,\n  .bank-pane > .bank-action-row .bank-full-exchange-btn,\n  .bank-pane > .bank-balance-card,\n  .bank-pane > .ant-alert {\n    height: auto !important;\n    min-height: 76px;\n  }\n\n  .bank-pane > .bank-input-card,\n  .bank-pane:has(> .bank-action-row) > .bank-input-card {\n    padding: 10px;\n  }\n\n  .bank-pane .bank-input-card > .ant-btn,\n  .bank-pane:has(> .bank-action-row) .bank-input-card > .ant-btn {\n    flex-basis: 50px;\n    height: 50px !important;\n    min-height: 50px !important;\n  }\n\n  .bank-header .ant-segmented-item {\n    flex-basis: 58px;\n    min-height: 58px;\n  }\n\n  .bank-header .ant-segmented-item-label {\n    min-height: 54px;\n    padding: 7px 9px;\n  }\n}\n\n/* Wide-screen restraint: controls keep task-sized proportions and leave calm space. */\n.bank-pane,\n.bank-pane:has(> .bank-action-row) {\n  width: min(100%, 960px);\n  height: auto;\n  min-height: 0;\n  grid-template-rows: minmax(76px, auto) auto;\n  align-self: start;\n  overflow: visible;\n  background: transparent;\n}\n\n.bank-pane > .bank-action-row {\n  grid-template-rows: minmax(76px, auto);\n}\n\n.bank-pane > .bank-action-row .bank-balance-card,\n.bank-pane > .bank-action-row .bank-full-exchange-btn,\n.bank-pane > .bank-balance-card,\n.bank-pane > .ant-alert {\n  min-height: 76px;\n}\n\n.bank-pane > .bank-input-card,\n.bank-pane:has(> .bank-action-row) > .bank-input-card {\n  height: auto;\n  min-height: 176px;\n  max-height: none;\n}\n\n.bank-pane .bank-amount-display,\n.bank-pane:has(> .bank-action-row) .bank-amount-display {\n  flex: 0 0 92px;\n  height: 92px !important;\n  min-height: 92px;\n}\n\n.bank-pane .bank-input-card > .ant-btn,\n.bank-pane:has(> .bank-action-row) .bank-input-card > .ant-btn {\n  flex: 0 0 52px;\n  height: 52px !important;\n  min-height: 52px !important;\n}\n\n/* Member card contents: identity first, passport status always on its owner. */\n.bank-header .ant-segmented-group {\n  height: auto !important;\n  justify-content: flex-start !important;\n  align-items: stretch;\n}\n\n.bank-header .ant-segmented-item {\n  flex: 0 0 auto !important;\n  height: auto !important;\n  min-height: 68px;\n  max-height: none;\n}\n\n.bank-header .ant-segmented-item-label {\n  min-height: 66px;\n  padding: 9px 10px;\n}\n\n.bank-member-option {\n  width: 100%;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n  gap: 5px;\n  text-align: left;\n}\n\n.bank-member-summary {\n  width: 100%;\n  min-width: 0;\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 7px;\n}\n\n.bank-member-name {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  color: inherit;\n  font-size: 15px;\n  font-weight: 800;\n}\n\n.bank-member-balance {\n  flex: 0 0 auto;\n  color: inherit;\n  font-size: 14px;\n  font-weight: 800;\n  font-variant-numeric: tabular-nums;\n}\n\n.bank-member-passport {\n  display: inline-flex;\n  align-items: center;\n  min-height: 20px;\n  padding: 2px 7px;\n  border-radius: 4px;\n  color: #63308c;\n  background: #f0e4f8;\n  font-size: 12px;\n  font-weight: 800;\n  line-height: 1.2;\n}\n\n.bank-header .ant-segmented-item:has(input:checked) .bank-member-passport,\n.bank-header .ant-segmented-item-selected .bank-member-passport,\n.bank-header > .ant-typography .bank-member-passport {\n  color: #fff;\n  background: rgba(255, 255, 255, 0.22);\n}\n\n/* The old selected-member passport strip is no longer rendered. */\n.bank-tab-allinone > .bank-header + .ant-tag {\n  display: none;\n}\n\n.bank-header,\n.bank-tab-allinone:has(> .bank-header + .ant-tag) > .bank-header {\n  padding: 44px 9px 9px;\n}\n\n/* Search and service selectors share one larger tablet touch row. */\n.all-pane-left .pane-title.member-search-title,\n.all-pane-center > .ant-tabs > .ant-tabs-nav {\n  box-sizing: border-box;\n  height: 84px;\n  min-height: 84px;\n}\n\n.all-pane-left .pane-title.member-search-title {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n  gap: 3px;\n  padding: 10px 16px;\n}\n\n.member-search-title-main {\n  font-size: clamp(17px, 1.45vw, 19px);\n  font-weight: 900;\n  line-height: 1.2;\n}\n\n.member-search-title-help {\n  color: #c9d8e3;\n  font-size: clamp(12px, 1vw, 13px);\n  font-weight: 600;\n  line-height: 1.2;\n}\n\n.all-pane-center > .ant-tabs > .ant-tabs-nav {\n  padding-block: 7px;\n}\n\n.all-pane-center > .ant-tabs.ant-tabs-card > .ant-tabs-nav .ant-tabs-tab {\n  height: 70px;\n  min-height: 70px;\n  align-items: center;\n  justify-content: center;\n}\n\n@media (orientation: landscape) and (max-height: 700px) {\n  .bank-pane,\n  .bank-pane:has(> .bank-action-row) {\n    grid-template-rows: minmax(70px, auto) auto;\n  }\n\n  .bank-pane > .bank-action-row {\n    grid-template-rows: minmax(70px, auto);\n  }\n\n  .bank-pane > .bank-action-row .bank-balance-card,\n  .bank-pane > .bank-action-row .bank-full-exchange-btn,\n  .bank-pane > .bank-balance-card,\n  .bank-pane > .ant-alert {\n    min-height: 70px;\n  }\n\n  .bank-pane > .bank-input-card,\n  .bank-pane:has(> .bank-action-row) > .bank-input-card {\n    min-height: 164px;\n  }\n\n  .bank-pane .bank-amount-display,\n  .bank-pane:has(> .bank-action-row) .bank-amount-display {\n    flex-basis: 84px;\n    height: 84px !important;\n    min-height: 84px;\n  }\n\n  .bank-header,\n  .bank-tab-allinone:has(> .bank-header + .ant-tag) > .bank-header {\n    padding: 40px 7px 7px;\n  }\n}\n\n/* Phone entry uses the complete field width without changing digit typography. */\n.all-in-one-page .all-pane-left .phone-display {\n  grid-template-columns: 44px minmax(0, 1fr);\n  column-gap: 3px;\n}\n\n.all-in-one-page .all-pane-left .phone-prefix {\n  width: 44px;\n}\n\n.all-in-one-page .all-pane-left .phone-digits {\n  width: 100%;\n  grid-template-columns: repeat(8, minmax(0, 1fr));\n  column-gap: 0;\n}\n\n/* Explicitly reset obsolete grid coordinates that caused exchange controls to overlap. */\n.bank-pane:has(> .bank-action-row) > .bank-action-row {\n  position: relative;\n  z-index: 1;\n  grid-column: 1;\n  grid-row: 1;\n  width: 100%;\n  height: 76px;\n  min-height: 76px;\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  grid-template-rows: 76px;\n  gap: 12px;\n  overflow: visible;\n}\n\n.bank-pane:has(> .bank-action-row) > .bank-action-row > .bank-balance-card {\n  grid-column: 1 !important;\n  grid-row: 1 !important;\n  width: 100% !important;\n  height: 76px !important;\n  min-height: 76px;\n}\n\n.bank-pane:has(> .bank-action-row) > .bank-action-row > .bank-full-exchange-btn {\n  grid-column: 2 !important;\n  grid-row: 1 !important;\n  align-self: stretch;\n  width: 100% !important;\n  height: 76px !important;\n  min-height: 76px;\n  margin: 0 !important;\n}\n\n.bank-pane:has(> .bank-action-row) > .bank-input-card {\n  position: relative;\n  z-index: 1;\n  grid-column: 1;\n  grid-row: 2;\n  margin-top: 4px;\n  border: 1px solid #c8d3dc;\n  background: #fff;\n}\n\n.bank-pane:has(> .bank-action-row) > .bank-input-card .bank-amount-display,\n.bank-pane:has(> .bank-action-row) > .bank-input-card > .ant-btn,\n.bank-pane:has(> .bank-action-row) > .bank-input-card > .ant-alert {\n  position: static;\n  grid-column: auto;\n  grid-row: auto;\n  margin: 0;\n}\n\n@media (orientation: landscape) and (max-height: 700px) {\n  .bank-pane:has(> .bank-action-row) > .bank-action-row {\n    height: 70px;\n    min-height: 70px;\n    grid-template-rows: 70px;\n  }\n\n  .bank-pane:has(> .bank-action-row) > .bank-action-row > .bank-balance-card,\n  .bank-pane:has(> .bank-action-row) > .bank-action-row > .bank-full-exchange-btn {\n    height: 70px !important;\n    min-height: 70px;\n  }\n}\n\n/* Exchange variants: equal-height sibling cards, without filling the workspace. */\n.bank-pane:has(> .bank-action-row) {\n  width: min(100%, 960px);\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  grid-template-rows: 220px;\n  align-items: stretch;\n  gap: 12px;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  overflow: visible;\n}\n\n.bank-pane:has(> .bank-action-row) > .bank-action-row {\n  grid-column: 1;\n  grid-row: 1;\n  width: 100%;\n  height: 220px;\n  min-height: 220px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 12px;\n  border: 1px solid #c8d3dc;\n  border-radius: 8px;\n  background: #fff;\n}\n\n.bank-pane:has(> .bank-action-row) > .bank-action-row::before {\n  content: \"전량 인출\";\n  flex: 0 0 auto;\n  color: #21394c;\n  font-size: 16px;\n  font-weight: 800;\n  line-height: 1.4;\n}\n\n.bank-pane:has(> .bank-action-row) > .bank-action-row > .bank-balance-card {\n  flex: 1 1 auto;\n  width: 100% !important;\n  height: auto !important;\n  min-height: 76px;\n}\n\n.bank-pane:has(> .bank-action-row) > .bank-action-row > .bank-full-exchange-btn {\n  flex: 0 0 52px;\n  width: 100% !important;\n  height: 52px !important;\n  min-height: 52px;\n}\n\n.bank-pane:has(> .bank-action-row) > .bank-input-card {\n  grid-column: 2;\n  grid-row: 1;\n  width: 100%;\n  height: 220px;\n  min-height: 220px;\n  margin: 0;\n  padding: 12px;\n  border: 1px solid #c8d3dc;\n  border-radius: 8px;\n  background: #fff;\n}\n\n.bank-pane:has(> .bank-action-row) > .bank-input-card .bank-amount-display {\n  flex: 1 1 auto;\n  height: auto !important;\n  min-height: 76px;\n}\n\n.bank-pane:has(> .bank-action-row) > .bank-input-card > .ant-btn {\n  flex: 0 0 52px;\n  height: 52px !important;\n  min-height: 52px !important;\n}\n\n@media (orientation: landscape) and (max-height: 700px) {\n  .bank-pane:has(> .bank-action-row) {\n    grid-template-rows: 204px;\n  }\n\n  .bank-pane:has(> .bank-action-row) > .bank-action-row,\n  .bank-pane:has(> .bank-action-row) > .bank-input-card {\n    height: 204px;\n    min-height: 204px;\n    padding: 10px;\n  }\n\n  .bank-pane:has(> .bank-action-row) > .bank-action-row > .bank-full-exchange-btn,\n  .bank-pane:has(> .bank-action-row) > .bank-input-card > .ant-btn {\n    flex-basis: 48px;\n    height: 48px !important;\n    min-height: 48px !important;\n  }\n}\n\n/* Exchange cards grow together when the remaining-balance notice appears. */\n.bank-pane:has(> .bank-action-row) {\n  grid-template-rows: minmax(220px, auto);\n  align-items: stretch;\n}\n\n.bank-pane:has(> .bank-action-row) > .bank-action-row,\n.bank-pane:has(> .bank-action-row) > .bank-input-card {\n  height: auto;\n  min-height: 220px;\n  align-self: stretch;\n}\n\n/* Donation stays identifiable while disabled; opacity alone communicates state. */\n.bank-tab-allinone button[data-testid=\"btn-bank-donate\"],\n.bank-tab-allinone button[data-testid=\"btn-bank-donate\"]:disabled {\n  color: #fff !important;\n  border-color: #c2185b !important;\n  background: #c2185b !important;\n}\n\n.bank-tab-allinone button[data-testid=\"btn-bank-donate\"]:disabled {\n  opacity: 0.55;\n}\n\n@media (orientation: landscape) and (max-height: 700px) {\n  .bank-pane:has(> .bank-action-row) {\n    grid-template-rows: minmax(204px, auto);\n  }\n\n  .bank-pane:has(> .bank-action-row) > .bank-action-row,\n  .bank-pane:has(> .bank-action-row) > .bank-input-card {\n    height: auto;\n    min-height: 204px;\n  }\n}\n\n/* Final readability pass for the target selector. */\n.bank-header::before {\n  font-size: 18px;\n  line-height: 1.3;\n}\n\n.bank-member-name {\n  font-size: clamp(16px, 1.45vw, 18px);\n  line-height: 1.35;\n  font-weight: 900;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
